<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-interactions-transcript-search-filters">
    <div class="search-section">
      <div ref="searchBox" class="search">
        <div class="div-search-input">
          <div class="search-button material-icons">search</div>
          <el-input
            ref="searchInput"
            class="search-inp"
            placeholder="Search transcripts"
            v-model="searchKeyword"
            @focus="onSearchFocus"
            @blur="onSearchBlur"
            @keypress.enter.native="applySearch"
          ></el-input><i v-if="searchKeyword!=''" class="fas fa-times-circle" @click="clearSearchInput"></i>
        </div>
        <el-popover transition="" @hide="handleClickOutsideOfPopover" v-model="showAdvancedSearchFilter" placement="bottom-start" popper-class="interactions-advanced-wrapper">
          <el-tooltip slot="reference" ref="advancedSearchTooltip" content="Show search options" effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom">
            <div @mouseover="onSearchHover" @mouseout="onSearchLeave" @click="handleOpenAdvancedSearch" class="advanced-search-icon"></div>
          </el-tooltip>
          <div class="cus-msg-card">
            <div class="agent-title">Advanced Search Options
              <div class="btn-select-all" @click="handleCancelAdvancedSearch">
              </div>
            </div>
            <div class="horizontal-line">
              <div class="filter-section mutiple-select-section agent-groups">
                <div class="title-inside">Search:</div>
                <div class="div-search-dropdown">
                  <el-select ref="searchInputOption" v-model="searchType"
                    @focus="onSearchFocus" @blur="onSearchBlur" popper-class="interaction-transcript-search-filter-dropdown" placeholder="Select">
                    <el-option
                      v-for="item in searchTypeList"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                      :disabled="item.disabled">
                    </el-option>
                  </el-select>
                </div>

                <div v-if="searchType=='1'" class="title-inside">Find results:</div>
                <div v-if="searchType=='1'" class="find-results-section" style="padding-bottom: 20px">
                  <el-select ref="sentByOption" v-model="sentBy" :disabled="searchType == '2'" default-first-option
                    @focus="onSearchFocus" @blur="onSearchBlur" popper-class="interaction-transcript-search-filter-dropdown-sent-by" placeholder="Message type">
                    <el-option
                      v-for="item in sentByList"
                      :key="item.key"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled">
                    </el-option>
                  </el-select>
                  <span class="prefix-label" :class="{'disabled':searchType=='2'}">In:</span>
                </div>
              </div>
            </div>
            
            <div class="card-bottom-part">
              <span class="transcript-search-cancel-btn" @click="handleCancelAdvancedSearch">Cancel</span>
              <div class="wrapper"><span class="transcript-search-apply-btn" @click="handleApplyAdvancedSearch">Apply</span></div>
            </div>
          </div>
        </el-popover>
        
      </div>
      <div v-if="contactReason && contactReason != ''" class="export-div">
        <el-button  v-if="transcriptSearchResultsComponent && transcriptSearchResultsComponent.totalMatchedConversations>0" class="submit-btn transcript-detail-export-btn" round @click="applyExport">
          <div class="export-icon"></div>
          <span class="export-text">Export</span>
        </el-button>
      </div>
    </div>

    <div class="verticalLine">
      
    </div>
    <el-button :disabled="disabledSearchFilters" class="el-dropdown submit-btn save-transcript-btn" :class="transcriptSearchResultsComponent && savedTranscriptResult ? 'saved-transcript-filter' : ''" @click="toggleSavedTranscriptFilter">
      <span class="text">View saved transcripts</span>
    </el-button>
    
    <el-dropdown trigger="click" ref="agentHandlingTimeFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.agentHandlingTimeFilter)">
      <el-button :disabled="disabledSearchFilters" name="handling time dropdown btn" class="other" :class="{'selected':localFilters.agentHandlingTime.updated}" data-testid="TrendingTopic-AiGeneratedTopics-TopicDetail-TranscriptsTab-CallHandleTimeFilter">
        <span class="handling-time reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.agentHandlingTimeFilter, resetAgentHandlingTimeRange)"></span>
        <span class="text filterLabel">Call Handle Time</span>
        <span v-if="localFilters.agentHandlingTime.updated" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':localFilters.agentHandlingTime.updated}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-interactions-transcript-search-dropdown-menu handling-time"
        slot="dropdown"
      >
        <div class="cus-msg-card handling-time">

          <div class="filter-header">
            Call Handle Time

            <div class="btn-select-all" @click="handleCancel($refs.agentHandlingTimeFilter)">
            </div>
            <div v-show="agentHandlingTimeHasError" class="invalid-time-range">
              You have entered an invalid time range
            </div>
          </div>
          <div class="horizontal-line">
            <div class="time">
              <wy-time-picker
                v-model="agentHandlingTimeFilter.fromValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentHandlingTimeHasError"
                manual-input
                :componentType="'transcriptSearch'"
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
              <span class="dash">-</span>
              <wy-time-picker
                v-model="agentHandlingTimeFilter.toValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentHandlingTimeHasError"
                manual-input
                :componentType="'transcriptSearch'"
                hide-dropdown
                input-width="130px"
              ></wy-time-picker> 
            </div>
            <div class="flex">
              <div v-if="localFilters.agentHandlingTime.minAgentHandlingTimeDisplay" class="min-hint">Min: {{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.hh}}:{{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.mm}}:{{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.ss}}</div>
              <div v-if="localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay" class="max-hint">Max: {{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.hh}}:{{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.mm}}:{{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.ss}}</div>
            </div>
          </div>
          <div class="card-bottom-part">
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.agentHandlingTimeFilter)">Cancel</span>
            <el-button v-if="localFilters.agentHandlingTime.updated" plain class="clear-btn" @click="resetAgentHandlingTimeRange()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.agentHandlingTimeFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dropdown trigger="click" ref="responseTimeFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.responseTimeFilter)">
      <el-button :disabled="disabledSearchFilters" name="res time dropdown btn" class="other" :class="{'selected':localFilters.agentResponseTime.updated}" data-testid="TrendingTopic-AiGeneratedTopics-TopicDetail-TranscriptsTab-AgentResponseTimeFilter">
        <span class="response-time reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.responseTimeFilter, resetAgentResponseTimeRange)"></span>
        <span class="text filterLabel">Agent Response Time</span>
        <span v-if="localFilters.agentResponseTime.updated" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':localFilters.agentResponseTime.updated}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-interactions-transcript-search-dropdown-menu response-time"
        slot="dropdown"
      >
        <div class="cus-msg-card handling-time">
          <div class="filter-header">
            Agent Response Time:

            <div class="btn-select-all" @click="handleCancel($refs.responseTimeFilter)">
            </div>

            <div v-show="agentResponseTimeHasError" class="invalid-time-range">
              You have entered an invalid time range
            </div>
          </div>
          <div class="horizontal-line">
            <div class="time">
              <wy-time-picker
                ref="agentResponseTimeFilter"
                v-model="agentResponseTimeFilter.fromValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentResponseTimeHasError"
                :componentType="'transcriptSearch'"
                end="200"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
              <span class="dash">-</span>
              <wy-time-picker
                v-model="agentResponseTimeFilter.toValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentResponseTimeHasError"
                :componentType="'transcriptSearch'"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
            </div>
            <div class="flex">
              <div v-if="localFilters.agentResponseTime.minAgentResponseTimeDisplay" class="min-hint">Min: {{localFilters.agentResponseTime.minAgentResponseTimeDisplay.hh}}:{{localFilters.agentResponseTime.minAgentResponseTimeDisplay.mm}}:{{localFilters.agentResponseTime.minAgentResponseTimeDisplay.ss}}</div>
              <div v-if="localFilters.agentResponseTime.maxAgentResponseTimeDisplay" class="max-hint">Max: {{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.hh}}:{{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.mm}}:{{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.ss}}</div>
            </div>
          </div>
          <div class="card-bottom-part">
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.responseTimeFilter)">Cancel</span>
            <el-button v-if="localFilters.agentResponseTime.updated" plain class="clear-btn" @click="resetAgentResponseTimeRange()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.responseTimeFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

   
    <el-popover v-model="showAgentFilters" placement="bottom-start" popper-class="wy-analytics-interactions-transcript-search-dropdown-menu agents" trigger="click" ref="localAgentFilter"
      v-if="dataModel.filters"
      @hide="handleHideAllFilters($refs.localAgentFilter,'Organization')" @show="handleShowAllFilters($refs.localAgentFilter)" class="el-dropdown">
      <div class="cus-msg-card">
        <div class="agent-title">Organization
          <div class="btn-select-all" @click="handleAgentCancel">
            <!-- <img src="../../../assets/icons/icon_transcript_close.svg" @click="handleAgentCancel"> -->
          </div>
        </div>
        <div ref="agentFilterContent" class="horizontal-line">
          <div class="filter-section mutiple-select-section agent-groups">
            <wy-filter-item-multi-select ref="localAgentGroupsDropdown" v-if="localAgentGroups
                && dataModel.filters"
                :agent = "true" className="agent-popper"
                :filter="localAgentGroups" :dataSource="agentGroupsDataSource" :filterChangedCallback="agentGroupsChangedCallback" :dropdownDisabled="agentGroupsDisabled" />
          </div>

          <div  class="filter-section mutiple-select-section agent-teams">
            <div class="agent-dropdown">
            <wy-filter-item-multi-select class="transcript-search" ref="localAgentTeamsDropdown" v-if="localAgentTeams
                && dataModel.filters"
                :agent = "true" className="agent-popper"
                :filter="localAgentTeams" :dataSource="agentTeamsDataSource" :filterChangedCallback="agentTeamsChangedCallback" :dropdownDisabled="agentTeamsDisabled" />
                </div>
          </div>
          
          <div class="filter-section mutiple-select-section agents">
                <wy-filter-item-multi-select ref="localAgentsDropdown" v-if="localAgents
                && dataModel.filters"
                :agent = "true" className="agent-popper"
                :filter="localAgents" :dataSource="agentsDataSource" :filterChangedCallback="agentsChangedCallback" :dropdownDisabled="agentsDisabled" />
          </div>
        </div>
        
        <div class="card-bottom-part">
          <span class="transcript-search-cancel-btn" @click="handleAgentCancel">Cancel</span>
          <el-button v-if="(transcriptFilters['agentTeams'] && transcriptFilters['agentTeams'].length>0)||
            (transcriptFilters['agentGroups'] && transcriptFilters['agentGroups'].length>0)||
            (transcriptFilters['agents'] && transcriptFilters['agents'].length>0)"
            plain class="clear-btn" @click="resetAgents()">
              <span class="clear-filter-text">Reset all</span>
            </el-button>
          <div class="wrapper"><span class="transcript-search-apply-btn" :class="{'disabled': !localFilterChanged}" @click="handleHideAllFilters($refs.localAgentFilter, 'Organization')">Apply</span></div>
        </div>
      </div>
      <el-button slot="reference" @click="showDropdownsAgentFilters" :disabled="disabledSearchFilters" name="containment dropdown btn" class="other" :class="{'selected':localFilters.agent.updated}" data-testid="TrendingTopic-AiGeneratedTopics-TopicDetail-TranscriptsTab-OrganizationFilter">
          <span class="agent reset-btn-icon" style="display: none;" @click="resetAgentApply($event, $refs.localAgentFilter)"></span>
          <span class="text">Organization</span>
          <span v-if="localFilters.agent.updated" class="applied-filter-number"></span>
          <i class="el-icon-arrow-down el-icon--right" :class="{'hide':localFilters.agent.updated}"></i>
      </el-button>
    </el-popover>

    <div class="last-verticalLine"/>

    <el-popover
      placement="bottom-start"
      width="160"
      ref="allFilters"
      v-model="showAllFilters"
      class="el-dropdown"
      popper-class = 'allFilters-popover interactions trending-topic-detail'
      @show="handleShowAllFilters($refs.allFilters)"
      @hide="handleHideAllFilters($refs.allFilters, 'All Filters')">
      <div ref="allFiltersCard" class="cus-msg-card all-filter-card">
        <div class="filter-header"> All Filters

        <div class="btn-select-all" @click="handleCancelAllfilters">
          <!-- <img src="../../../assets/icons/icon_transcript_close.svg" @click="handleCancelAllfilters"> -->
        </div>
        </div>
        <div ref="contentEl" class="content">
          <div class="horizontal-line">
            <div class="handle-time">
              <div class="all-filter-top-two-title">
                Call Handle Time:
                <div v-show="agentHandlingTimeHasError" class="invalid-time-range">
                  You have entered an invalid time range
                </div>
              </div>
              <div class="time">
                <wy-time-picker
                  v-model="agentHandlingTimeFilter.fromValue"
                  format="hh:mm:ss"
                  :timePickerInputHasError="agentHandlingTimeHasError"
                  :componentType="'transcriptSearch'"
                  manual-input
                  hide-dropdown
                  input-width="130px"
                ></wy-time-picker>
                <span class="dash">-</span>
                <wy-time-picker
                  v-model="agentHandlingTimeFilter.toValue"
                  format="hh:mm:ss"
                  :timePickerInputHasError="agentHandlingTimeHasError"
                  :componentType="'transcriptSearch'"
                  manual-input
                  hide-dropdown
                  input-width="130px"
                ></wy-time-picker>
              </div>
              <div class="flex">
                <div v-if="localFilters.agentHandlingTime.minAgentHandlingTimeDisplay" class="min-hint">Min: {{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.hh}}:{{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.mm}}:{{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.ss}}</div>
                <div v-if="localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay" class="max-hint">Max: {{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.hh}}:{{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.mm}}:{{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.ss}}</div>
              </div>
            </div>

            <div class="handle-time">
              <div class="all-filter-top-two-title">
                Agent Response Time:
                <div v-show="agentResponseTimeHasError" class="invalid-time-range">
                  You have entered an invalid time range
                </div>
              </div>
              <div class="time">
                <wy-time-picker
                  ref="agentResponseTimeFilter"
                  v-model="agentResponseTimeFilter.fromValue"
                  format="hh:mm:ss"
                  :timePickerInputHasError="agentResponseTimeHasError"
                  :componentType="'transcriptSearch'"
                  end="200"
                  manual-input
                  hide-dropdown
                  input-width="130px"
                ></wy-time-picker>
                <span class="dash">-</span>
                <wy-time-picker
                  v-model="agentResponseTimeFilter.toValue"
                  format="hh:mm:ss"
                  :timePickerInputHasError="agentResponseTimeHasError"
                  :componentType="'transcriptSearch'"
                  manual-input
                  hide-dropdown
                  input-width="130px"
                ></wy-time-picker>
              </div>
              <div class="flex">
                <div v-if="localFilters.agentResponseTime.minAgentResponseTimeDisplay" class="min-hint">Min: {{localFilters.agentResponseTime.minAgentResponseTimeDisplay.hh}}:{{localFilters.agentResponseTime.minAgentResponseTimeDisplay.mm}}:{{localFilters.agentResponseTime.minAgentResponseTimeDisplay.ss}}</div>
                <div v-if="localFilters.agentResponseTime.maxAgentResponseTimeDisplay" class="max-hint">Max: {{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.hh}}:{{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.mm}}:{{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.ss}}</div>
              </div>
            </div>

            <div class="agent-filters" v-if="dataModel.filters">
              <div class="all-filter-top-two-title">
                Organization
              </div>
              <div class="agent-container">
                <div class="filter-section mutiple-select-section agent-groups">
                  <wy-filter-item-multi-select className="agent-popper" ref="localAgentGroupsDropdownAllFilter" v-if="localAgentGroups
                      && dataModel.filters"
                      :filter="localAgentGroups" :dataSource="agentGroupsDataSource" :filterChangedCallback="agentGroupsChangedCallback" :dropdownDisabled="agentGroupsDisabled" />
                </div>
                <div class="filter-section mutiple-select-section agent-teams">
                  <wy-filter-item-multi-select className="agent-popper" ref="localAgentTeamsDropdownAllFilter" v-if="localAgentTeams
                      && dataModel.filters"
                      :filter="localAgentTeams" :dataSource="agentTeamsDataSource" :filterChangedCallback="agentTeamsChangedCallback" :dropdownDisabled="agentTeamsDisabled" />
                </div>
                  
                <div class="filter-section mutiple-select-section agents">
                  <wy-filter-item-multi-select className="agent-popper" ref="localAgentsDropdownAllFilter" v-if="localAgents
                  && dataModel.filters"
                  :filter="localAgents" :dataSource="agentsDataSource" :filterChangedCallback="agentsChangedCallback" :dropdownDisabled="agentsDisabled" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-bottom-part">
          <span class="transcript-search-cancel-btn" @click="handleCancelAllfilters">Cancel</span>
          <el-button plain class="clear-btn" v-if="localFilters.agentHandlingTime.updated||localFilters.agentResponseTime.updated||localFilters.agent.updated" @click="handleClearAllFilters"><span class="clear-filter-text">Reset all</span></el-button>
          <div class="wrapper"><span class="transcript-search-apply-btn" @click="handleHideAllFilters($refs.allFilters, 'All Filters')">Apply</span></div>
        </div>
      </div>
      <el-button @click="showDropdownsAllFilters" slot="reference" :disabled="disabledSearchFilters" name="all-filters-btn dropdown btn" class="other" :class="{'selected':appliedFilterCount>0}" data-testid="TrendingTopic-AiGeneratedTopics-TopicDetail-TranscriptsTab-AllFilters">
        <span class="all-filters reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.allFilters, handleClearAllFilters)"></span>
        <span class="text">All Filters</span>
        <span v-if="appliedFilterCount>0" class="applied-filter-number"> ({{appliedFilterCount}})</span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':appliedFilterCount>0}"></i>
      </el-button>
    </el-popover>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import WyTimePicker from "../../widgets/wy-time-picker";
import WyUtils from '../../../library/wy-utils.js';
import WyFilterItemMultiSelect from '../../widgets/wy-filters/wy-filter-item-multi-select';
// import _ from 'lodash';

const CONTAINMENT_OPTIONS = Object.freeze({
  CONTAINED: "Contained",
  LIVE_AGENT_REQUESTED: "Live Agent Requested",
  NOT_CONNECTED: "Live Agent Requested but not Connected",
  LIVE_AGENT_CONNECTED: "Live Agent Connected",
});

export default Vue.extend({
  name: "wy-analytics-interactions-transcript-search-filters",
  components: {
    "wy-time-picker": WyTimePicker,
    'wy-filter-item-multi-select': WyFilterItemMultiSelect,
  },
  props: ['controller', 'contactReason'],

  data() {
    return {
      transcriptSearchResultsComponent: {},
      transcriptFilters: {},
      savedTranscriptResult: false,
      isSavedTranscriptResultSelected: false,

      topicFilterLoading: false,

      localFilters: {
        responseTime: {
          updated: false
        },
        handlingTime: {
          updated: false
        },
        handOffs: {
          updated: false
        },
        agent: {
          update: false
        },
        agentHandlingTime: {
          updated: false
        },
        agentResponseTime: {
          updated: false
        },
        agentWaitTime: {
          updated: false
        }
      },
      localFilterMap: {},
      defaultLocalFilterMap: {},

      searchKeyword: '',

      contactReasonKeywords: '',
      responseNameKeywords: '',
      intentNameKeywords: '',
      relatedTopicKeywords: '',

      containmentList: [
        { key: "BotOnlyContained", label: CONTAINMENT_OPTIONS.CONTAINED },
        { key: "BotOnlyEscalated", label: CONTAINMENT_OPTIONS.LIVE_AGENT_REQUESTED },
        { key: "BotOnlyEscalated", label: CONTAINMENT_OPTIONS.NOT_CONNECTED },
        { key: "BotToLC", label: CONTAINMENT_OPTIONS.LIVE_AGENT_CONNECTED },
      ],
      sentimentList: [{key: "pos", label: "Positive"}, {key: "neu", label: "Neutral"},{key: "neg", label: "Negative"}],
      feedbackList: [{key: "pos", label: "Positive"}, {key: "neg", label: "Negative"}],

      //OC-1805
      besSignalsList: [
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Bot Repetition"], label: "Bot Repetition", tooltipContent: 'The virtual agent repeats itself within 3 consecutive messages during a conversation.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["User Abandoned"], label: "User Abandoned", tooltipContent: 'The customer drops off from a conversation without reaching a legitimate end response configured on the bot.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Negative Sentiment"], label: "Negative Sentiment" , tooltipContent: 'AI-detected sentiment from the latter half of virtual agent conversations, where at least three user messages are received.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Repeated Escalation Requests"], label: "Repeated Escalation Requests" , tooltipContent: 'The customer requests to be escalated multiple times within a conversation.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Negative Feedback"], label: "Negative Feedback" , tooltipContent: 'The customer provides explicit negative feedback in a conversation.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Profanity"], label: "Profanity" , tooltipContent: 'Profanity detected in customer messages within a conversation.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["User Paraphrases"], label: "User Paraphrases" , tooltipContent: 'The customer uses a similar query twice or more within a conversation.' },
      ],

      selectedBesSignals: [],

      basSignalsList: [
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["Escalation"], label: "Escalation" , tooltipContent: 'The customer is escalated or handed off to a live agent.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["User Abandoned"], label: "User Abandoned" , tooltipContent: 'The customer drops off from a conversation without reaching a legitimate end response configured on the bot.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["Escalation not Connected"], label: "Escalation not Connected" , tooltipContent: 'The customer requests to be connected to a live agent but the handoff from virtual to live agent does not take place.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["False Positives"], label: "False Positives" , tooltipContent: 'The customer received an unrelated response to their query.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["Negative Feedback"], label: "Negative Feedback" , tooltipContent: 'The virtual agent receives explicit negative feedback from the customer during a conversation.' },
      ],

      selectedBasSignals: [],
      //OC-1805

      //OC-1883 Advanced Search Filter
      showAdvancedSearchFilter: false,
      showAdvancedSearchFilterSticky: false,
      // Search By
      searchType: '1',
      searchTypeList: [
        {key: '1', label: 'Transcripts', disabled: false},
        {key: '2', label: 'Contact ID', disabled: false}
      ],
      // Search For
      searchFor: '1',
      searchForList: [
        {key: '1', label: 'Exact match', disabled: false},
        {key: '2', label: 'Contains', disabled: false},
      ],
      sentBy: '',
      sentByList: [
        {key: '1', label: 'All messages', value: null, disabled: false},
        {key: '2', label: 'Agent messages', value: 'A', disabled: false},
        {key: '3', label: 'Customer messages', value: 'U', disabled: false},  
      ],
      // Search In
      searchIn: [],
      searchInList: [
        {key: '1', label: 'User messages', apiField: 'Customer', disabled: false, checked: true},
        {key: '2', label: 'Virtual Agent messages', apiField: 'Bot', disabled: false, checked: true},
        {key: '3', label: 'Live Agent messages', apiField: 'Agent', disabled: false, checked: true},
      ],

      contactReasonsList: [],
      selectedContactReasons: [],
      // selectedContactReasonsDisplay: [],
      selectedContainment: [],
      selectedSentiment: [],
      selectedFeedback: [],

      responseNameList: [],
      selectedResponseNames: [],

      relatedTopicList: [],
      selectedRelatedTopics: [],

      intentNameList: [],
      selectedIntentNames: [],

      handlingTimeFilter: {},
      showAppliedSearchCross: false,
      responseTimeFilter: {},
      handOffsFilter: {},
      appliedFilterCount: 0,
      appliedSearchKeyword: false,

      agentHandlingTimeFilter: {},
      agentResponseTimeFilter: {},
      agentWaitTimeFilter: {},

      isCanceled: false,
      showAllFilters: false,
      agentDropdownClosed: false,
      showAgentFilters: false,
      // isSelectedAll: false

      handlingTimeHasError: false,
      responseTimeHasError: false,
      handOffsHasError: false,

      agentHandlingTimeHasError: false,
      agentResponseTimeHasError: false,
      agentWaitTimeHasError: false,

      //agent related
      localAgentTeams: null,
      localAgentGroups: null,
      localAgents: null,
      agentTeamsDataSource: null,
      agentGroupsDataSource: null,
      agentsDataSource: null,

      isContactReasonSelectedAll: false,
      isResponseNameSelectedAll: false,
      isIntentNameSelectedAll: false,
      isRelatedTopicsSelectedAll: false,

      handOffsMin: false,
      handOffsMax: false,

      triggeredFromAllFiltersBtn: false,
      triggeredFromAgentFiltersBtn: false,

      agentGroupsDisabled: false,
      agentTeamsDisabled: false,
      agentsDisabled: false,

      localSearchApplied: false,
      localFilterChanged: false
    };
  },

  computed: {
    ...mapGetters(["dataModel", "isRoleAllow", 'localStorage', 'companyConfig']),

    companyHasLiveAgent() {
      const config = this.companyConfig && this.companyConfig.api && this.companyConfig.api.configs && this.companyConfig.api.configs.hasLiveAgent
      if (config === undefined || config === null) return true;

      return config
    },

    disabledSearchFilters() {
      return false;//this.transcriptSearchResultsComponent.totalMatchedConversations <= 1;
    },

    filterdContactReasons() {
      return this.getFilteredContactReasons();
    },

    filteredResponseNames() {
      return this.getFilteredResponseNames();
    },

    filteredIntentNames() {
      return this.getFilteredIntentNames();
    },

    filteredRelatedTopics() {
      return this.getFilteredRelatedTopics();
    },


    hasContactReason() {
      return !(!this.contactReason || this.contactReason == '')
    },

    isFilterChanged() {
      let changed = false;
      if(this.defaultLocalFilterMap.localAgentTeams) {
        if(//JSON.stringify(this.handlingTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.handlingTimeFilter)
        // || JSON.stringify(this.responseTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.responseTimeFilter)
        // || JSON.stringify(this.handOffsFilter) != JSON.stringify(this.defaultLocalFilterMap.handOffsFilter)
        JSON.stringify(this.agentHandlingTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.agentHandlingTimeFilter)
        || JSON.stringify(this.agentResponseTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.agentResponseTimeFilter)
        // || JSON.stringify(this.agentWaitTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.agentWaitTimeFilter)
        // || this.checkArrayEqual(this.selectedContactReasons, this.defaultLocalFilterMap.selectedContactReasons)
        // || this.checkArrayEqual(this.selectedResponseNames, this.defaultLocalFilterMap.selectedResponseNames)
        // || this.checkArrayEqual(this.selectedRelatedTopics, this.defaultLocalFilterMap.selectedRelatedTopics)
        // || this.checkArrayEqual(this.selectedIntentNames, this.defaultLocalFilterMap.selectedIntentNames)
        // || this.checkArrayEqual(this.selectedSentiment, this.defaultLocalFilterMap.selectedSentiment)
        // || this.checkArrayEqual(this.selectedFeedback, this.defaultLocalFilterMap.selectedFeedback)
        // || this.checkArrayEqual(this.selectedBesSignals, this.defaultLocalFilterMap.selectedBesSignals)
        // || this.checkArrayEqual(this.selectedBasSignals, this.defaultLocalFilterMap.selectedBasSignals)
        // || this.checkArrayEqual(this.selectedContainment, this.defaultLocalFilterMap.selectedContainment)
          || JSON.stringify(this.localAgentTeams.value) != JSON.stringify(this.defaultLocalFilterMap.localAgentTeams.value)
          || JSON.stringify(this.localAgentGroups.value) != JSON.stringify(this.defaultLocalFilterMap.localAgentGroups.value)
          || JSON.stringify(this.localAgents.value) != JSON.stringify(this.defaultLocalFilterMap.localAgents.value)) {
          changed = true;
          
        }
      }
      
      return changed;
    },
  },

  watch: {
      // searchType: {
      //   // reference handleResetAllAdvancedSearch
      //   handler: function(newValue) {
      //     if (newValue == '2') {
      //       this.searchIn = [];
      //       this.searchFor = '1'
      //       this.searchKeyword = '';
      //       this.removeAllSearchTags();
      //     } else {
      //       this.searchIn = ['1', '2', '3'];
      //     }
      //   },
      //   deep: true
      // },
      handlingTimeFilter: {
          handler: function(newValue) {
              this.handlingTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      responseTimeFilter: {
          handler: function(newValue) {
              this.responseTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      handOffsFilter: {
          handler: function(newValue) {
              this.handOffsHasError = newValue.fromValue > newValue.toValue;
          },
          deep: true
      },
      agentHandlingTimeFilter: {
          handler: function(newValue) {
              this.agentHandlingTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      agentResponseTimeFilter: {
          handler: function(newValue) {
              this.agentResponseTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      agentWaitTimeFilter: {
          handler: function(newValue) {
              this.agentWaitTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      selectedContactReasons: {
        handler: function(newValue) {
          this.isContactReasonSelectedAll = true;
          // this.selectedContactReasonsDisplay = [];
          this.filterdContactReasons.forEach(filteredItem => {
            if (newValue.includes(filteredItem.topicDisplayName)) {
              // this.selectedContactReasonsDisplay.push(filteredItem.topicDisplayName);
            }
            else {
              this.isContactReasonSelectedAll = false;
            }
          })
        },
        deep: true
      },
      selectedResponseNames: {
        handler: function(newValue) {
          this.isResponseNameSelectedAll = true;
          this.filteredResponseNames.forEach(filteredItem => {
            if (!newValue.includes(filteredItem.responseName)) {
              this.isResponseNameSelectedAll = false;
            }
          })
        },
        deep: true
      },
      selectedRelatedTopics: {
        handler: function(newValue) {
          this.isRelatedTopicsSelectedAll = true;
          this.filteredRelatedTopics.forEach(filteredItem => {
            if (!newValue.includes(filteredItem.topicName)) {
              this.isRelatedTopicsSelectedAll = false;
            }
          })
        },
        deep: true
      },
      selectedIntentNames: {
        handler: function(newValue) {
          this.isIntentNameSelectedAll = true;
          this.filteredIntentNames.forEach(filteredItem => {
            if (!newValue.includes(filteredItem.intentName)) {
              this.isIntentNameSelectedAll = false;
            }
          })
        },
        deep: true
      },
  },

  methods: {
    getFilteredContactReasons() {
      let filteredList = this.contactReasonsList ? this.contactReasonsList.filter(item => {
        return item.topicDisplayName.toLowerCase().includes(this.contactReasonKeywords.trim().toLowerCase())
      }) : [];

      if (this.selectedContactReasons.length === 0 || filteredList.length > this.selectedContactReasons.length) {
        this.isContactReasonSelectedAll = false;
      }
      else {
        this.isContactReasonSelectedAll = true;
        filteredList.forEach(item => {
          if (!this.selectedContactReasons.includes(item.topicDisplayName)) {
            this.isContactReasonSelectedAll = false;
          }
        })
      }
      return filteredList;
    },

    getFilteredResponseNames() {
      let filteredList = this.responseNameList ? this.responseNameList.filter(item => {
        return item.responseName.toLowerCase().includes(this.responseNameKeywords.trim().toLowerCase())
      }) : [];

      if (this.selectedResponseNames.length === 0 || filteredList.length > this.selectedResponseNames.length) {
        this.isResponseNameSelectedAll = false;
      }
      else {
        this.isResponseNameSelectedAll = true;
        filteredList.forEach(item => {
          if (!this.selectedResponseNames.includes(item.responseName)) {
            this.isResponseNameSelectedAll = false;
          }
        })
      }
      return filteredList;
    },

    getFilteredIntentNames() {
      let filteredList = this.intentNameList ? this.intentNameList.filter(item => {
        return item.intentName.toLowerCase().includes(this.intentNameKeywords.trim().toLowerCase())
      }) : [];

      if (this.selectedIntentNames.length === 0 || filteredList.length > this.selectedIntentNames.length) {
        this.isIntentNameSelectedAll = false;
      }
      else {
        this.isIntentNameSelectedAll = true;
        filteredList.forEach(item => {
          if (!this.selectedIntentNames.includes(item.intentName)) {
            this.isIntentNameSelectedAll = false;
          }
        })
      }
      return filteredList;
    },

    getFilteredRelatedTopics() {
      let filteredList = this.relatedTopicList ? this.relatedTopicList.filter(item => {
        return item.topicName.toLowerCase().includes(this.relatedTopicKeywords.trim().toLowerCase())
      }) : [];

      if (this.selectedRelatedTopics.length === 0 || filteredList.length > this.selectedRelatedTopics.length) {
        this.isRelatedTopicsSelectedAll = false;
      }
      else {
        this.isRelatedTopicsSelectedAll = true;
        filteredList.forEach(item => {
          if (!this.selectedRelatedTopics.includes(item.topicName)) {
            this.isRelatedTopicsSelectedAll = false;
          }
        })
      }
      return filteredList;
    },

    handOffsFocusMin() {
      this.handOffsMin = !this.handOffsMin
    },
    handOffsFocusMax() {
      this.handOffsMax = !this.handOffsMax
    },
    async handleFilterChange() {
      this.localSearchApplied = false;
      //agent queue, agent group, agent id
      this.localAgentTeams = JSON.parse(JSON.stringify(this.dataModel.filters.agentTeams));
      this.localFilterMap.localAgentTeams = JSON.parse(JSON.stringify(this.dataModel.filters.agentTeams));
      this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
      this.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
      this.localAgents = JSON.parse(JSON.stringify(this.dataModel.filters.agents));
      this.localFilterMap.localAgents = JSON.parse(JSON.stringify(this.dataModel.filters.agents));

      if(this.transcriptFilters['agentTeams'] && this.transcriptFilters['agentTeams'].length>0 && this.appliedFilterCount >= 1) {
          this.appliedFilterCount  = this.appliedFilterCount - 1;
          if(this.localAgentTeams != null) {
            let agentTeamsFilter = this.dataModel.filters.agentTeams.value || [];
            this.transcriptFilters['agentTeams'] = agentTeamsFilter;
          }
      }
      if(this.transcriptFilters['agentGroups'] && this.transcriptFilters['agentGroups'].length>0 && this.appliedFilterCount >= 1) {
          this.appliedFilterCount  = this.appliedFilterCount - 1;
          if(this.localAgentGroups != null) {
            let agentGroupsFilter = this.dataModel.filters.agentGroups.value || [];
            this.transcriptFilters['agentGroups'] = agentGroupsFilter;
          }
      }
      if(this.transcriptFilters['agents'] && this.transcriptFilters['agents'].length>0 && this.appliedFilterCount >= 1) {
          this.appliedFilterCount  = this.appliedFilterCount - 1;
          if(this.localAgents != null) {
            let agentsFilter = this.dataModel.filters.agents.value || [];
            this.transcriptFilters['agents'] = agentsFilter;
          }
      }

      if((!this.transcriptFilters['agentTeams'] ||  (this.transcriptFilters['agentTeams'] && this.transcriptFilters['agentTeams'].length == 0))
        && (!this.transcriptFilters['agentGroups'] || (this.transcriptFilters['agentGroups'] && this.transcriptFilters['agentGroups'].length == 0))
        && (!this.transcriptFilters['agents'] || (this.transcriptFilters['agents'] && this.transcriptFilters['agents'].length == 0))
        ){
          this.localFilters.agent.updated = false;
      }
    },

    //handle Agent related.......
    agentTeamsChangedCallback() {
      if(!this.localAgents.isDisabled){
        this.agentsDataSource = this.dataModel.filters.agents.dataSource;
        let agentsValues = this.agentsDataSource.map(item => item.key);
        this.localAgents.isDisabled = (this.dataModel.filters.agents.value.length !== 0);
        this.localAgents.value = this.localAgents.value.filter(val => agentsValues.includes(val));
        this.localAgents.isEmpty = (this.agentsDataSource.length == 1 && this.agentsDataSource[0].key == 'all');
      }

      let agentTeamsComponent = this.$refs.localAgentTeamsDropdown;
      let agentsComponent = this.$refs.localAgentsDropdown;
      if(!this.showAgentFilters) {
        agentTeamsComponent = this.$refs.localAgentTeamsDropdownAllFilter;
        agentsComponent = this.$refs.localAgentsDropdownAllFilter;
      }
      agentsComponent.localDataSource = [];
      let filterTeams = agentTeamsComponent.preSelectedFilters
      if(filterTeams.length == 0) {
        filterTeams = [];
        this.agentTeamsDataSource.forEach(el => {
          filterTeams.push(el.key)
        })
      }
      if(filterTeams.includes("all")) {
        filterTeams = [];
        this.agentTeamsDataSource.forEach(el => {
          filterTeams.push(el.key)
        })
      }
      let selectedAgents =  this.agentsDataSource.filter(agent => filterTeams.includes(agent.teamId));
      if(selectedAgents.length > 0) {
        agentsComponent.localDataSource.push(this.agentsDataSource[0]);
      }
      agentsComponent.localDataSource = agentsComponent.localDataSource.concat(selectedAgents);
      agentsComponent.cloneLocalDataSource = agentsComponent.localDataSource;
      this.agentsDataSource = agentsComponent.localDataSource;
      if(agentTeamsComponent.filter.value.length > 0) {
        this.agentGroupsDisabled = true;
      }
      else {
        this.agentGroupsDisabled = false;
      }
      this.localFilterChanged = this.checkFilterChanges();
    },

    showDropdowns(){
      setTimeout(() => {
        document.querySelectorAll('.el-select-dropdown__wrap').forEach(el => {
        el.style.display = "block";
        })
      }, 100);
    },

    showDropdownsAgentFilters() {
      this.triggeredFromAgentFiltersBtn = true;
      this.showDropdowns()
    },

    showDropdownsAllFilters () {
      this.triggeredFromAllFiltersBtn = true;
      this.showDropdowns()
    },

    pageChanged(pageNo) {
      this.transcriptFilters['action'] = 'search';
      this.transcriptFilters['searchBy'] = this.searchType;
      this.transcriptFilters['searchFor'] = this.searchFor;
      this.transcriptFilters['sentBy'] = this.sentBy === '' ? null : this.sentBy;
      this.transcriptFilters['searchIn'] = this.searchIn.map(item => this.searchInList.find(listItem => listItem.key === item).apiField);
      this.loadTopicConversations(pageNo, false, "Page Scroll");
    },
    handleAgentCancel(){
      this.isCanceled = true;
      this.agentCancel();
    },
    agentCancel() {
      this.showAgentFilters = false;

      this.localAgentTeams = JSON.parse(JSON.stringify(this.localFilterMap.localAgentTeams));
      this.localAgentGroups = JSON.parse(JSON.stringify(this.localFilterMap.localAgentGroups));
      this.localAgents = JSON.parse(JSON.stringify(this.localFilterMap.localAgents));

      let agentGroupsComponent = this.$refs.localAgentGroupsDropdown;
      let agentTeamsComponent = this.$refs.localAgentTeamsDropdown;
      let agentsComponent = this.$refs.localAgentsDropdown;
      if(!this.showAgentFilters) {
        agentGroupsComponent = this.$refs.localAgentGroupsDropdownAllFilter;
        agentTeamsComponent = this.$refs.localAgentTeamsDropdownAllFilter;
        agentsComponent = this.$refs.localAgentsDropdownAllFilter;
      }
      agentGroupsComponent.preSelectedFilters = this.localAgentGroups.value
      agentTeamsComponent.preSelectedFilters = this.localAgentTeams.value
      agentsComponent.preSelectedFilters = this.localAgents.value
      setTimeout(()=>{
        this.agentGroupsChangedCallback()
        this.agentTeamsChangedCallback()
        this.agentsChangedCallback()
      }, 100)
    },

    agentGroupsChangedCallback() {
      if(!this.localAgentTeams.isDisabled){
        this.agentTeamsDataSource = this.dataModel.filters.agentTeams.dataSource;
        let agentTeamsValues = this.agentTeamsDataSource.map(item => item.key);
        this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
        this.localAgentTeams.isDisabled = (this.dataModel.filters.agentTeams.value.length !== 0);
        this.localAgentTeams.value = this.localAgentTeams.value.filter(val => agentTeamsValues.includes(val));
        this.localAgentTeams.isEmpty = (this.agentTeamsDataSource.length == 1 && this.agentTeamsDataSource[0].key == 'all');
      }
      if(!this.localAgents.isDisabled) {
        this.agentsDataSource = this.dataModel.filters.agents.dataSource;
        let agentsValues = this.agentsDataSource.map(item => item.key);
        this.localAgents.isDisabled = (this.dataModel.filters.agents.value.length !== 0);
        this.localAgents.value = this.localAgents.value.filter(val => agentsValues.includes(val));
        this.localAgents.isEmpty = (this.agentsDataSource.length == 1 && this.agentsDataSource[0].key == 'all');
      }

      let agentGroupsComponent = this.$refs.localAgentGroupsDropdown;
      let agentTeamsComponent = this.$refs.localAgentTeamsDropdown;
      let agentsComponent = this.$refs.localAgentsDropdown;
      if(!this.showAgentFilters) {
        agentGroupsComponent = this.$refs.localAgentGroupsDropdownAllFilter;
        agentTeamsComponent = this.$refs.localAgentTeamsDropdownAllFilter;
        agentsComponent = this.$refs.localAgentsDropdownAllFilter;
      }
      let filterGroups = agentGroupsComponent.preSelectedFilters
      if(filterGroups.length == 0) {
        filterGroups = [];
        this.agentGroupsDataSource.forEach(el => {
          filterGroups.push(el.key)
        })
      }
      if(filterGroups.includes("all")) {
        filterGroups = [];
        this.agentGroupsDataSource.forEach(el => {
          filterGroups.push(el.key)
        })
      }
      agentTeamsComponent.localDataSource = [];
      agentsComponent.localDataSource = [];
      let selectedAgentTeams = this.agentTeamsDataSource.filter(team => filterGroups.includes(team.groupId));
      if(selectedAgentTeams.length > 0) {
        agentTeamsComponent.localDataSource.push(this.agentTeamsDataSource[0]);
        agentTeamsComponent.localDataSource = agentTeamsComponent.localDataSource.concat(selectedAgentTeams);
      }
      agentTeamsComponent.cloneLocalDataSource = agentTeamsComponent.localDataSource;
      this.agentTeamsDataSource = agentTeamsComponent.localDataSource;
      const teamKeys = agentTeamsComponent.localDataSource.map(team => team.key)
      let selectedAgents =  this.agentsDataSource.filter(agent => teamKeys.includes(agent.teamId));
      if(selectedAgents.length > 0) {
        agentsComponent.localDataSource.push(this.agentsDataSource[0]);
      }
      agentsComponent.localDataSource = agentsComponent.localDataSource.concat(selectedAgents);
      agentsComponent.cloneLocalDataSource = agentsComponent.localDataSource;
      this.agentsDataSource = agentsComponent.localDataSource;
      this.localFilterChanged = this.checkFilterChanges();
    },

    agentsChangedCallback() {
      let agentTeamsComponent = this.$refs.localAgentTeamsDropdown;
      let agentsComponent = this.$refs.localAgentsDropdown;
      if(!this.showAgentFilters) {
        agentTeamsComponent = this.$refs.localAgentTeamsDropdownAllFilter;
        agentsComponent = this.$refs.localAgentsDropdownAllFilter;
      }
      if(agentsComponent.filter.value.length > 0) {
        this.agentGroupsDisabled = true;
        this.agentTeamsDisabled = true;
      }
      else {
        this.agentTeamsDisabled = false;
        if(agentTeamsComponent.filter.value.length > 0) {
          this.agentGroupsDisabled = true;
        }
        else {
          this.agentGroupsDisabled = false;
        }
      }
      this.localFilterChanged = this.checkFilterChanges();
    },

    clearSearch(ref) {
      if (ref == this.$refs.contactReasonFilter || ref == this.$refs.contactReasonFilterAllFilter) {
        this.contactReasonKeywords = '';
      }
      else if (ref == this.$refs.responseNameFilter || ref == this.$refs.responseNameFilterAllFilter) {
        this.responseNameKeywords = '';
      }
      else if (ref == this.$refs.relatedTopicsFilter || ref == this.$refs.relatedTopicFilterAllFilter) {
        this.relatedTopicKeywords = '';
      }
      else if (ref == this.$refs.intentNameFilter || ref == this.$refs.intentNameFilterAllFilter) {
        this.intentNameKeywords = '';
      }
    },

    clearSearchInput() {
      this.handleResetAllAdvancedSearch();
      this.handleCloseAdvancedSearch();
      this.applySearch();
    },

    checkError(from, to) {
      if(from && to) {
        let fromValue = parseInt(from.hh*3600) + parseInt(from.mm*60) + parseInt(from.ss)
        let toValue = parseInt(to.hh*3600) + parseInt(to.mm*60) + parseInt(to.ss)
        return fromValue > toValue
      }
      else {
        return false
      }
    },

    handleShowAllFilters(el) {
      setTimeout(()=>{
        this.agentDropdownClosed = false;
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.add('el-icon-arrow-up')
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-down')
        el.$el.firstElementChild.classList.add("with-border")
        this.isCanceled = false;
        if(this.isCanceled) {
          this.isCanceled = false;
        }
        else {
          if(this.localAgentTeams.value.length !== 0){
            this.$refs.localAgentTeamsDropdown.isChanged(true);
            this.$refs.localAgentTeamsDropdownAllFilter.isChanged(true);
          } 
          if(this.localAgentGroups.value.length !== 0){
            this.$refs.localAgentGroupsDropdown.isChanged(true);
            this.$refs.localAgentGroupsDropdownAllFilter.isChanged(true);
          }
          if(this.localAgents.value.length !== 0){
            this.$refs.localAgentsDropdown.isChanged(true);
            this.$refs.localAgentsDropdownAllFilter.isChanged(true);
          }
          if(this.localSearchApplied) {
            this.localAgentTeams.isDisabled = (this.dataModel.filters.agentTeams.value.length !== 0);
            this.localFilterMap.localAgentTeams = JSON.parse(JSON.stringify(this.localAgentTeams));
            this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
            this.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.localAgentGroups))
            this.localAgents.isDisabled = (this.dataModel.filters.agents.value.length !== 0);
            this.localFilterMap.localAgents = JSON.parse(JSON.stringify(this.localAgents));
          }
        }
      }, 200)
      if(!this.localSearchApplied) {
        this.prepareFilters();
        this.refreshAgentFilters();
        this.localFilterMap.localAgentGroups.value = this.dataModel.filters.agentGroups.value
        this.localFilterMap.localAgentTeams.value = this.dataModel.filters.agentTeams.value
        this.localFilterMap.localAgents.value = this.dataModel.filters.agents.value

        this.defaultLocalFilterMap =  JSON.parse(JSON.stringify(this.localFilterMap));
        this.localAgentTeams.isDisabled = (this.dataModel.filters.agentTeams.value.length !== 0);
        this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
        this.localAgents.isDisabled = (this.dataModel.filters.agents.value.length !== 0);
        this.localFilters.agent.updated = false;
      }
    },

    handleHideAllFilters(el, applySearchfilterName) {
      this.agentDropdownClosed = true;
      document.querySelectorAll(".el-dropdown-menu.el-popper.all-filters-contact-reasons").forEach(el => {
        el.style.display = "none";
      })
      if(el && el.$el) {
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.add('el-icon-arrow-down')
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-up')
        el.$el.firstElementChild.classList.remove("with-border")
      }
      if(this.isCanceled) {
        this.isCanceled = false;
      }
      else {
        if(this.$refs.localAgentsDropdown) this.$refs.localAgentsDropdown.closeDropdown();
        if(this.$refs.localAgentTeamsDropdown) this.$refs.localAgentTeamsDropdown.closeDropdown();
        if(this.$refs.localAgentGroupsDropdown) this.$refs.localAgentGroupsDropdown.closeDropdown();
        if(this.$refs.localAgentsDropdownAllFilter) this.$refs.localAgentsDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentTeamsDropdownAllFilter) this.$refs.localAgentTeamsDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentGroupsDropdownAllFilter) this.$refs.localAgentGroupsDropdownAllFilter.closeDropdown();
        if(this.checkFilterChanges()) {
          this.applySearch(null, applySearchfilterName);
          this.showAppliedSearchCross = true;
        } else {
          this.showAppliedSearchCross = false;
        }
      }
    },

    arrayMove(arr, old_index, new_index) {
      if (new_index >= arr.length) {
          var k = new_index - arr.length + 1;
          while (k--) {
              arr.push(undefined);
          }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    },

    handleChangeVisible(isShowing, el) {
      const filterLabelEl = el.$el.querySelector(".filterLabel");
      const filterLabelText = filterLabelEl ? filterLabelEl.innerText.trim() : null;
      if(isShowing) {
        this.isCanceled = false;
        if(el == this.$refs.contactReasonFilter && this.selectedContactReasons.length > 0) {
          let newIndex = 0
          this.contactReasonsList.forEach((item, index) => {
            this.selectedContactReasons.forEach(selectedTopicName => {
              if(item.topicDisplayName == selectedTopicName) {
                this.contactReasonsList = this.arrayMove(this.contactReasonsList, index, newIndex);
                newIndex ++;
              }
              else {
                // restArray.push(item)
              }
            })
          })
        }
        // Response Name Filter
        if(el == this.$refs.responseNameFilter && this.selectedResponseNames.length > 0) {
          let newIndex = 0
          this.responseNameList.forEach((item, index) => {
            this.selectedResponseNames.forEach(selectedResponseName => {
              if(item.responseName == selectedResponseName) {
                this.responseNameList = this.arrayMove(this.responseNameList, index, newIndex);
                newIndex ++;
              }
            })
          })
        }
        // Related Topic Filter
        if(el == this.$refs.relatedTopicsFilter && this.selectedRelatedTopics.length > 0) {
          let newIndex = 0
          this.relatedTopicList.forEach((item, index) => {
            this.selectedRelatedTopics.forEach(selectedRelatedTopic => {
              if(item.topicName == selectedRelatedTopic) {
                this.relatedTopicList = this.arrayMove(this.relatedTopicList, index, newIndex);
                newIndex ++;
              }
            })
          })
        }
        // Intent Name Filter
        if(el == this.$refs.intentNameFilter && this.selectedIntentNames.length > 0) {
          let newIndex = 0
          this.intentNameList.forEach((item, index) => {
            this.selectedIntentNames.forEach(selectedIntentName => {
              if(item.intentName == selectedIntentName) {
                this.intentNameList = this.arrayMove(this.intentNameList, index, newIndex);
                newIndex ++;
              }
            })
          })
        }

        el.show();
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.add('el-icon-arrow-up')
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-down')
        el.$el.firstElementChild.classList.add("with-border");
      }
      else {
        if(el) {
          el.$el.firstElementChild.firstElementChild.lastElementChild.classList.add('el-icon-arrow-down')
          el.$el.firstElementChild.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-up')
          el.$el.firstElementChild.classList.remove("with-border");
          if(el.hide) {
            el.hide();
          }
          else {
            this.handleHideAllFilters(el, 'All Filters');
            // this.cancelAllfilters();
          }
        }
        if(this.isCanceled) {
          this.isCanceled = false;
        }
        else {
          const isListFilter = 
            el == this.$refs.contactReasonFilterAllFilter
            || el == this.$refs.responseNameFilterAllFilter 
            || el == this.$refs.relatedTopicFilterAllFilter 
            || el == this.$refs.intentNameFilterAllFilter;

          if(isListFilter){
            if(this.checkFilterChanges() && this.agentDropdownClosed) {
              this.applySearch(null, filterLabelText);
            }
          }
          else {
            if(this.checkFilterChanges()) {
              this.applySearch(null, filterLabelText);
            }
          }
        }
      }
    },

    checkAdvancedFilterChanges() {
      let changed = false;
      if (this.searchType != this.localFilterMap.searchType
      || this.searchFor != this.localFilterMap.searchFor
      || this.sentBy != this.localFilterMap.sentBy
      || this.searchKeyword != this.localFilterMap.searchKeyword
      || this.checkArrayEqual(this.searchIn, this.localFilterMap.searchIn)
      ) {
        changed = true
      }
      return changed
    },

    checkFilterChanges() {
      let changed = false;
      if(
        JSON.stringify(this.agentHandlingTimeFilter) != JSON.stringify(this.localFilterMap.agentHandlingTimeFilter)
        || JSON.stringify(this.agentResponseTimeFilter) != JSON.stringify(this.localFilterMap.agentResponseTimeFilter)
        || JSON.stringify(this.localAgentTeams.value) != JSON.stringify(this.localFilterMap.localAgentTeams.value)
        || JSON.stringify(this.localAgentGroups.value) != JSON.stringify(this.localFilterMap.localAgentGroups.value)
        || JSON.stringify(this.localAgents.value) != JSON.stringify(this.localFilterMap.localAgents.value)) {
        changed = true;
      }
      return changed;
    },

    checkArrayEqual(array1, array2) {
      let changed = false;
      if(!array1) {
        array1 = []
      }
      if(!array2) {
        array2 = []
      }
      array1.forEach(item=>{
        if(!array2.includes(item)) {
          changed = true
        }
      })
      array2.forEach(item=>{
        if(!array1.includes(item)) {
          changed = true
        }
      })
      return changed;
    },

    handleClearAllFilters(){
      this.resetAgentResponseTimeRange();
      this.resetAgentHandlingTimeRange();
      this.resetHandoffs();

      if(this.contactReason && this.contactReason != "") {
        // this.transcriptFilters['topicDisplayNames'] = [this.contactReason];
        this.selectedContactReasons = [this.contactReason];
      }
      else {
        this.resetContactReasons();
      }
      this.resetContainment();
      this.resetResponseName();
      this.resetRelatedTopics();
      this.resetIntentNames();

      this.resetSentiment();
      this.resetFeedback();
      this.resetAgents();
      this.resetBesSignals();
      this.resetBasSignals();
      
    },

    handleClearLocalAgentFilters(){
      this.localAgentTeams = JSON.parse(JSON.stringify(this.dataModel.filters.agentTeams));
      this.localAgentTeams.label = this.localAgentTeams.label;
      this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
      this.localAgentGroups.label = this.localAgentGroups.label;
      this.localAgents = JSON.parse(JSON.stringify(this.dataModel.filters.agents));
      this.localAgents.label = this.localAgents.label;
    },

    resetAgentApply(e, el) {
      e.stopPropagation();
      this.resetAgents();
      this.isCanceled = false;
      this.handleHideAllFilters(el, 'Organization');
    },

    resetContactReasonApply(e, el) {
      e.stopPropagation();
      this.selectedContactReasons = [];
      this.isCanceled = false;
      this.handleChangeVisible(false, el);
    },

    resetContainmentApply(e, el) {
      e.stopPropagation();
      this.selectedContainment = [];
      this.isCanceled = false;
      this.handleChangeVisible(false, el);
    },

    resetHandlingTimeApply(e, el) {
      e.stopPropagation();
      // this.selectedContainment = [];
      this.isCanceled = false;
      this.handleChangeVisible(false, el);
    },
    resetApply(e, el, resetCallback) {
      e.stopPropagation();
      // this.selectedContainment = [];
      resetCallback()
      this.isCanceled = false;
      this.handleChangeVisible(false, el);
    },

    handleApply(el) {
      this.isCanceled = false;
      el.hide();
    },

    handleCancel(el) {
      this.isCanceled = true;
      el.hide();
      this.selectedContactReasons = JSON.parse(JSON.stringify(this.localFilterMap.selectedContactReasons));
      this.selectedResponseNames = JSON.parse(JSON.stringify(this.localFilterMap.selectedResponseNames));
      this.selectedRelatedTopics = JSON.parse(JSON.stringify(this.localFilterMap.selectedRelatedTopics));
      this.selectedIntentNames = JSON.parse(JSON.stringify(this.localFilterMap.selectedIntentNames));
      this.selectedContainment = this.localFilterMap.selectedContainment;
      this.selectedSentiment = this.localFilterMap.selectedSentiment;
      this.selectedFeedback = this.localFilterMap.selectedFeedback;
      this.selectedBesSignals = this.localFilterMap.selectedBesSignals;
      this.selectedBasSignals = this.localFilterMap.selectedBasSignals;
      this.handlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.handlingTimeFilter));
      this.responseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.responseTimeFilter));
      this.handOffsFilter = JSON.parse(JSON.stringify(this.localFilterMap.handOffsFilter));
      this.agentHandlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentHandlingTimeFilter));
      this.agentResponseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentResponseTimeFilter));
      this.agentWaitTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentWaitTimeFilter));
      // this.localAgentTeams = JSON.parse(JSON.stringify(this.localFilterMap.localAgentTeams));
      // this.localAgentGroups = JSON.parse(JSON.stringify(this.localFilterMap.localAgentGroups));
      // this.localAgents = JSON.parse(JSON.stringify(this.localFilterMap.localAgents));
    },

    handleCancelAllfilters() {
      this.isCanceled = true;
      this.showAdvancedSearchFilter = false;
      this.showAgentFilters = false;
      this.cancelAllfilters();
    },

    cancelAllfilters() {
      this.showAllFilters = false;
      if(this.localFilterMap && this.localFilterMap.selectedContactReasons) {
        this.selectedContactReasons = JSON.parse(JSON.stringify(this.localFilterMap.selectedContactReasons));
        this.selectedResponseNames = JSON.parse(JSON.stringify(this.localFilterMap.selectedResponseNames));
        this.selectedRelatedTopics = JSON.parse(JSON.stringify(this.localFilterMap.selectedRelatedTopics));
        this.selectedIntentNames = JSON.parse(JSON.stringify(this.localFilterMap.selectedIntentNames));
        this.selectedContainment = this.localFilterMap.selectedContainment;
        this.selectedSentiment = this.localFilterMap.selectedSentiment;
        this.selectedFeedback = this.localFilterMap.selectedFeedback;
        this.selectedBesSignals = this.localFilterMap.selectedBesSignals;
        this.selectedBasSignals = this.localFilterMap.selectedBasSignals;
        this.handlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.handlingTimeFilter));
        this.responseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.responseTimeFilter));
        this.handOffsFilter = JSON.parse(JSON.stringify(this.localFilterMap.handOffsFilter));
        this.agentHandlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentHandlingTimeFilter));
        this.agentResponseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentResponseTimeFilter)); 
        this.agentWaitTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentWaitTimeFilter));
        this.agentCancel();
      }
    },

    toggleSavedTranscriptFilter() {
      this.savedTranscriptResult = !this.savedTranscriptResult
      this.applySearch(null, "Saved Transcripts");
    },

    prepareFilters() {
      this.transcriptFilters = {};

      this.transcriptFilters['savedTranscripts'] = this.savedTranscriptResult;
      this.transcriptFilters['searchBy'] = this.searchType;
      this.transcriptFilters['searchFor'] = this.searchFor;
      this.transcriptFilters['sentBy'] = this.sentBy === '' ? null : this.sentBy;
      this.transcriptFilters['searchIn'] = this.searchIn.map(item => this.searchInList.find(listItem => listItem.key === item).apiField);

      this.transcriptFilters['searchKeyword'] = this.searchKeyword;
      if(this.contactReason && this.contactReason != "") {
        this.transcriptFilters['topicDisplayNames'] = [this.contactReason];
      }

      if(this.selectedContactReasons.length > 0) {
        this.transcriptFilters['topicDisplayNames'] = this.selectedContactReasons;
      }
      if(this.selectedResponseNames.length > 0) {
        this.transcriptFilters['responseNames'] = this.selectedResponseNames;
      }
      if(this.selectedRelatedTopics.length > 0) {
        this.transcriptFilters['relatedTopics'] = this.selectedRelatedTopics;
      }
      if(this.selectedIntentNames.length > 0) {
        this.transcriptFilters['intentNames'] = this.selectedIntentNames;
      }
      
      if(this.selectedContainment.length > 0) {
        // If global filter 'source' removed the value, also remove from the selectedContainment
        // const globalFilterSource = this.dataModel.filters && this.dataModel.filters.sources && this.dataModel.filters.sources.value
        // this.selectedContainment = this.selectedContainment.filter(value => {
        //   return globalFilterSource.includes(value);
        // });

        this.transcriptFilters['conversationTypes'] = this.selectedContainment;
      }
      if(this.selectedSentiment.length > 0) {
        this.transcriptFilters['sentiment'] = this.selectedSentiment;
      }
      if(this.selectedFeedback.length > 0) {
        this.transcriptFilters['feedback'] = this.selectedFeedback;
      }

      //agent queue, agent group, agent id
      if(this.localAgentTeams != null) {
        let agentTeamsFilter = JSON.parse(JSON.stringify(this.localAgentTeams.value)) || [];
        if(agentTeamsFilter.length > 0) {
          if(agentTeamsFilter.includes('all')) {
            agentTeamsFilter = agentTeamsFilter.filter(e => e !== 'all');
          }else if(agentTeamsFilter.includes('')) {
            agentTeamsFilter.push(null);
          }
          this.transcriptFilters['agentTeams'] = agentTeamsFilter;
        }
      }
      if(this.localAgentGroups != null) {
        let agentGroupsFilter = JSON.parse(JSON.stringify(this.localAgentGroups.value)) || [];
        if(agentGroupsFilter.length > 0) {
          if(agentGroupsFilter.includes('all')) {
            agentGroupsFilter = agentGroupsFilter.filter(e => e !== 'all');
          }else if(agentGroupsFilter.includes('')) {
            agentGroupsFilter.push(null);
          }
          this.transcriptFilters['agentGroups'] = agentGroupsFilter;
        }
      }
      if(this.localAgents != null) {
        let agentsFilter = JSON.parse(JSON.stringify(this.localAgents.value)) || [];
        if(agentsFilter.length > 0) {
          if(agentsFilter.includes('all')) {
            agentsFilter = agentsFilter.filter(e => e !== 'all');
          }else if(agentsFilter.includes('')) {
            agentsFilter.push(null);
          }
          this.transcriptFilters['agents'] = agentsFilter;
        }
      }
      // if(Object.keys(this.handlingTimeFilter).length > 0) {
      //   let timeRangeFilter = this.handleTimeRangeFilter(this.handlingTimeFilter);
      //   if(this.handlingTimeHasError) {
      //     let fromValue = this.handlingTimeFilter.fromValue;
      //     let toValue = this.handlingTimeFilter.toValue;
      //     this.handlingTimeFilter.fromValue = toValue;
      //     this.handlingTimeFilter.toValue = fromValue;
      //   }

      //   if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue === 0) {
      //     this.transcriptFilters['handleTimeMillisMin'] = timeRangeFilter.fromValue;
      //   }
      //   else {
      //     // this.transcriptFilters['handleTimeMillisMin'] = 0;
      //     delete this.transcriptFilters['handleTimeMillisMin']
      //   }
      //   if(timeRangeFilter.toValue || timeRangeFilter.toValue === 0) {
      //     this.transcriptFilters['handleTimeMillisMax'] = timeRangeFilter.toValue;
      //   }
      //   else {
      //     // this.transcriptFilters['handleTimeMillisMax'] = 0;
      //     delete this.transcriptFilters['handleTimeMillisMax']
      //   }
      // }
      // if(Object.keys(this.responseTimeFilter).length > 0) {
      //   let timeRangeFilter = this.handleTimeRangeFilter(this.responseTimeFilter);
      //   if(this.responseTimeHasError) {
      //     let fromValue = this.responseTimeFilter.fromValue;
      //     let toValue = this.responseTimeFilter.toValue;
      //     this.responseTimeFilter.fromValue = toValue;
      //     this.responseTimeFilter.toValue = fromValue;
      //   }

      //   if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue===0) {
      //     this.transcriptFilters['responseTimeMillisMin'] = timeRangeFilter.fromValue;
      //   }
      //   else {
      //     // this.transcriptFilters['responseTimeMillisMin'] = 0;
      //     delete this.transcriptFilters['responseTimeMillisMin']
      //   }
      //   if(timeRangeFilter.toValue || timeRangeFilter.toValue===0) {
      //     this.transcriptFilters['responseTimeMillisMax'] = timeRangeFilter.toValue;
      //   }
      //   else {
      //     // this.transcriptFilters['responseTimeMillisMax'] = 0;
      //     delete this.transcriptFilters['responseTimeMillisMax']
      //   }
      // }
      
      if(Object.keys(this.agentHandlingTimeFilter).length > 0) {
        let timeRangeFilter = this.handleTimeRangeFilter(this.agentHandlingTimeFilter);
        if(this.agentHandlingTimeHasError) {
          let fromValue = this.agentHandlingTimeFilter.fromValue;
          let toValue = this.agentHandlingTimeFilter.toValue;
          this.agentHandlingTimeFilter.fromValue = toValue;
          this.agentHandlingTimeFilter.toValue = fromValue;
        }

        if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue === 0) {
          this.transcriptFilters['agentHandleTimeMillisMin'] = timeRangeFilter.fromValue;
        }
        else {
          delete this.transcriptFilters['agentHandleTimeMillisMin']
        }
        if(timeRangeFilter.toValue || timeRangeFilter.toValue === 0) {
          this.transcriptFilters['agentHandleTimeMillisMax'] = timeRangeFilter.toValue;
        }
        else {
          delete this.transcriptFilters['agentHandleTimeMillisMax']
        }
      }
      if(Object.keys(this.agentResponseTimeFilter).length > 0) {
        let timeRangeFilter = this.handleTimeRangeFilter(this.agentResponseTimeFilter);
        if(this.agentResponseTimeHasError) {
          let fromValue = this.agentResponseTimeFilter.fromValue;
          let toValue = this.agentResponseTimeFilter.toValue;
          this.agentResponseTimeFilter.fromValue = toValue;
          this.agentResponseTimeFilter.toValue = fromValue;
        }

        if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue === 0) {
          this.transcriptFilters['agentResponseTimeMillisMin'] = timeRangeFilter.fromValue;
        }
        else {
          delete this.transcriptFilters['agentResponseTimeMillisMin']
        }
        if(timeRangeFilter.toValue || timeRangeFilter.toValue === 0) {
          this.transcriptFilters['agentResponseTimeMillisMax'] = timeRangeFilter.toValue;
        }
        else {
          delete this.transcriptFilters['agentResponseTimeMillisMax']
        }
      }
      // if(Object.keys(this.agentWaitTimeFilter).length > 0) {
      //   let timeRangeFilter = this.handleTimeRangeFilter(this.agentWaitTimeFilter);
      //   if(this.agentWaitTimeHasError) {
      //     let fromValue = this.agentWaitTimeFilter.fromValue;
      //     let toValue = this.agentWaitTimeFilter.toValue;
      //     this.agentWaitTimeFilter.fromValue = toValue;
      //     this.agentWaitTimeFilter.toValue = fromValue;
      //   }

      //   if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue === 0) {
      //     this.transcriptFilters['agentWaitTimeMillisMin'] = timeRangeFilter.fromValue;
      //   }
      //   else {
      //     delete this.transcriptFilters['agentWaitTimeMillisMin']
      //   }
      //   if(timeRangeFilter.toValue || timeRangeFilter.toValue === 0) {
      //     this.transcriptFilters['agentWaitTimeMillisMax'] = timeRangeFilter.toValue;
      //   }
      //   else {
      //     delete this.transcriptFilters['agentWaitTimeMillisMax']
      //   }
      // }

      // if(Object.keys(this.handOffsFilter).length > 0) {
      //   if((this.handOffsFilter.fromValue || this.handOffsFilter.fromValue === 0) && (this.handOffsFilter.toValue || this.handOffsFilter.toValue === 0)) {
      //     if(this.handOffsHasError) {
      //       let fromValue = this.handOffsFilter.fromValue;
      //       let toValue = this.handOffsFilter.toValue;
      //       this.handOffsFilter.fromValue = toValue;
      //       this.handOffsFilter.toValue = fromValue;
      //     }
      //     this.transcriptFilters['handOffsMin'] = (this.handOffsFilter.fromValue < this.handOffsFilter.toValue) ? this.handOffsFilter.fromValue : this.handOffsFilter.toValue;
      //     this.transcriptFilters['handOffsMax'] = (this.handOffsFilter.fromValue < this.handOffsFilter.toValue) ? this.handOffsFilter.toValue : this.handOffsFilter.fromValue;
      //   }
      //   else
      //   {
      //     if(this.handOffsFilter.fromValue || this.handOffsFilter.fromValue === 0) {
      //       this.transcriptFilters['handOffsMin'] = this.handOffsFilter.fromValue;
      //     }
      //     else {
      //       // this.transcriptFilters['handOffsMin'] = 0;
      //       delete this.transcriptFilters['handOffsMin']
      //     }
      //     if(this.handOffsFilter.toValue || this.handOffsFilter.toValue === 0) {
      //       this.transcriptFilters['handOffsMax'] = this.handOffsFilter.toValue;
      //     }
      //     else {
      //       // this.transcriptFilters['handOffsMax'] = 0;
      //       delete this.transcriptFilters['handOffsMax']
      //     }
      //   }

      //   //OC-1805
      //   //check if abandoned, negativefeedback get added/removed from the filter
      //   let abandonedRemoved = false;
      //   let abandonedAdded = false;
      //   let negativeFeedbackRemoved = false;
      //   let negativeFeedbackAdded = false;
      //   // //OC-1855
      //   // //check if BAS escalation (hasLiveAgentEscalationSignal) get added/removed from the filter
      //   // let escalationRemoved = false;
      //   // let escalationAdded = false;

      //   if((this.localFilterMap.selectedBesSignals && this.localFilterMap.selectedBesSignals.includes('hasAbandonedByUserSignal') && !this.selectedBesSignals.includes('hasAbandonedByUserSignal'))
      //   || (this.localFilterMap.selectedBasSignals && this.localFilterMap.selectedBasSignals.includes('hasAbandonedByUserSignal') && !this.selectedBasSignals.includes('hasAbandonedByUserSignal'))  
      //   ){
      //     abandonedRemoved = true;
      //   }
      //   if((this.localFilterMap.selectedBesSignals && !this.localFilterMap.selectedBesSignals.includes("hasAbandonedByUserSignal") && this.selectedBesSignals.includes('hasAbandonedByUserSignal'))
      //   || (this.localFilterMap.selectedBasSignals && !this.localFilterMap.selectedBasSignals.includes("hasAbandonedByUserSignal") && this.selectedBasSignals.includes('hasAbandonedByUserSignal'))  
      //   ){
      //     abandonedAdded = true;
      //   }

      //   if((this.localFilterMap.selectedBesSignals && this.localFilterMap.selectedBesSignals.includes('hasNegativeFeedbackSignal') && !this.selectedBesSignals.includes('hasNegativeFeedbackSignal'))
      //   || (this.localFilterMap.selectedBasSignals && this.localFilterMap.selectedBasSignals.includes('hasNegativeFeedbackSignal') && !this.selectedBasSignals.includes('hasNegativeFeedbackSignal'))  
      //   // || (this.localFilterMap.selectedFeedback && this.localFilterMap.selectedFeedback.includes('neg') && !this.selectedFeedback.includes('neg'))
      //   ){
      //     negativeFeedbackRemoved = true;
      //   }
      //   if((this.localFilterMap.selectedBesSignals && !this.localFilterMap.selectedBesSignals.includes('hasNegativeFeedbackSignal') && this.selectedBesSignals.includes('hasNegativeFeedbackSignal'))
      //   || (this.localFilterMap.selectedBasSignals && !this.localFilterMap.selectedBasSignals.includes('hasNegativeFeedbackSignal') && this.selectedBasSignals.includes('hasNegativeFeedbackSignal'))  
      //   // || (this.localFilterMap.selectedFeedback && !this.localFilterMap.selectedFeedback.includes('neg') && this.selectedFeedback.includes('neg'))
      //   ){
      //     negativeFeedbackAdded = true;
      //   }

      //   // if((this.localFilterMap.selectedBasSignals && this.localFilterMap.selectedBasSignals.includes('hasLiveAgentEscalationSignal') && !this.selectedBasSignals.includes('hasLiveAgentEscalationSignal'))
      //   // || (this.localFilterMap.selectedContainment && ['BotOnlyEscalated', 'BotToLC'].every(containment => this.localFilterMap.selectedContainment.includes(containment)) && !['BotOnlyEscalated', 'BotToLC'].every(containment => this.selectedContainment.includes(containment))) 
      //   // ){
      //   //   escalationRemoved = true;
      //   // }
      //   // if((this.localFilterMap.selectedBasSignals && !this.localFilterMap.selectedBasSignals.includes('hasLiveAgentEscalationSignal') && this.selectedBasSignals.includes('hasLiveAgentEscalationSignal'))
      //   // || (this.localFilterMap.selectedContainment && !['BotOnlyEscalated', 'BotToLC'].every(containment => this.localFilterMap.selectedContainment.includes(containment)) && ['BotOnlyEscalated', 'BotToLC'].every(containment => this.selectedContainment.includes(containment)))
      //   // ){
      //   //   escalationAdded = true;
      //   // }

      //   if(this.selectedBesSignals.length > 0 || this.selectedBasSignals.length > 0) { 
      //     //|| this.selectedFeedback.length > 0) {
      //     //if add, then push
      //     if(abandonedAdded) {
      //       if(!this.selectedBesSignals.includes('hasAbandonedByUserSignal')){
      //         this.selectedBesSignals.push('hasAbandonedByUserSignal');
      //       }
      //       if(!this.selectedBasSignals.includes('hasAbandonedByUserSignal')){
      //         this.selectedBasSignals.push('hasAbandonedByUserSignal');
      //       }
      //     }
      //     if(negativeFeedbackAdded) {
      //       if(!this.selectedBesSignals.includes('hasNegativeFeedbackSignal')){
      //         this.selectedBesSignals.push('hasNegativeFeedbackSignal');
      //       }
      //       if(!this.selectedBasSignals.includes('hasNegativeFeedbackSignal')){
      //         this.selectedBasSignals.push('hasNegativeFeedbackSignal');
      //       }
      //       // if(!this.selectedFeedback.includes('neg')){
      //       //   this.selectedFeedback.push('neg');
      //       // }
      //     }
      //     //if remove, then pop
      //     if(abandonedRemoved) {
      //       if(this.selectedBesSignals.includes('hasAbandonedByUserSignal')){
      //         this.selectedBesSignals = this.selectedBesSignals.filter(x => x !== 'hasAbandonedByUserSignal')
      //       }
      //       if(this.selectedBasSignals.includes('hasAbandonedByUserSignal')){
      //         this.selectedBasSignals = this.selectedBasSignals.filter(x => x !== 'hasAbandonedByUserSignal')
      //       }
      //     }
      //     if(negativeFeedbackRemoved) {
      //       if(this.selectedBesSignals.includes('hasNegativeFeedbackSignal')){
      //         this.selectedBesSignals = this.selectedBesSignals.filter(x => x !== 'hasNegativeFeedbackSignal')
      //       }
      //       if(this.selectedBasSignals.includes('hasNegativeFeedbackSignal')){
      //         this.selectedBasSignals = this.selectedBasSignals.filter(x => x !== 'hasNegativeFeedbackSignal')
      //       }
      //       // if(this.selectedFeedback.includes('neg')){
      //       //   this.selectedFeedback = this.selectedFeedback.filter(x => x !== 'neg')
      //       // }
      //     }
      //     this.transcriptFilters['besSignals'] = this.selectedBesSignals;
      //     this.transcriptFilters['basSignals'] = this.selectedBasSignals;
      //     // this.transcriptFilters['feedback'] = this.selectedFeedback;
      //   } //OC-1805

      //   // if(this.selectedBasSignals.length > 0 || this.selectedContainment.length > 0) {
      //   //   //if add, then push
      //   //   if(escalationAdded) {
      //   //     if(!this.selectedBasSignals.includes('hasLiveAgentEscalationSignal')){
      //   //       this.selectedBasSignals.push('hasLiveAgentEscalationSignal');
      //   //     }
      //   //     if(!['BotOnlyEscalated', 'BotToLC'].every(containment => this.selectedContainment.includes(containment))){
      //   //       ['BotOnlyEscalated', 'BotToLC'].forEach(containment => {
      //   //         if(!this.selectedContainment.includes(containment)){
      //   //           this.selectedContainment.push(containment);
      //   //         }
      //   //       });
      //   //     }
      //   //   }
      //   //   //if remove, then pop
      //   //   if(escalationRemoved) {
      //   //     if(this.selectedBasSignals.includes('hasLiveAgentEscalationSignal')){
      //   //       this.selectedBasSignals = this.selectedBasSignals.filter(x => x !== 'hasLiveAgentEscalationSignal')
      //   //     }
      //   //     if(['BotOnlyEscalated', 'BotToLC'].every(containment => this.selectedContainment.includes(containment))){
      //   //       this.selectedContainment = this.selectedContainment.filter(x => !['BotOnlyEscalated', 'BotToLC'].includes(x))
      //   //     }
      //   //   }

      //   //   this.transcriptFilters['basSignals'] = this.selectedBasSignals;
      //   //   this.transcriptFilters['conversationTypes'] = this.selectedContainment;
      //   // } //OC-1855
      // }
      this.localFilterMap.selectedContactReasons = JSON.parse(JSON.stringify(this.selectedContactReasons));
      this.localFilterMap.selectedResponseNames = JSON.parse(JSON.stringify(this.selectedResponseNames));
      this.localFilterMap.selectedRelatedTopics = JSON.parse(JSON.stringify(this.selectedRelatedTopics));
      this.localFilterMap.selectedIntentNames = JSON.parse(JSON.stringify(this.selectedIntentNames));

      this.localFilterMap.selectedContainment = this.selectedContainment;
      this.localFilterMap.selectedSentiment = this.selectedSentiment;
      this.localFilterMap.selectedFeedback = this.selectedFeedback;
      this.localFilterMap.selectedBesSignals = this.selectedBesSignals;
      this.localFilterMap.selectedBasSignals = this.selectedBasSignals;
      this.localFilterMap.handlingTimeFilter = JSON.parse(JSON.stringify(this.handlingTimeFilter));
      this.localFilterMap.responseTimeFilter = JSON.parse(JSON.stringify(this.responseTimeFilter));
      this.localFilterMap.handOffsFilter = JSON.parse(JSON.stringify(this.handOffsFilter));
      this.localFilterMap.agentHandlingTimeFilter = JSON.parse(JSON.stringify(this.agentHandlingTimeFilter));
      this.localFilterMap.agentResponseTimeFilter = JSON.parse(JSON.stringify(this.agentResponseTimeFilter));
      this.localFilterMap.agentWaitTimeFilter = JSON.parse(JSON.stringify(this.agentWaitTimeFilter));
      this.localFilterMap.localAgentTeams = JSON.parse(JSON.stringify(this.localAgentTeams));
      this.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.localAgentGroups));
      this.localFilterMap.localAgents = JSON.parse(JSON.stringify(this.localAgents));

      this.handlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.handlingTimeFilter));
      this.responseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.responseTimeFilter));
      this.handOffsFilter = JSON.parse(JSON.stringify(this.localFilterMap.handOffsFilter));
      this.agentHandlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentHandlingTimeFilter));
      this.agentResponseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentResponseTimeFilter));
      this.agentWaitTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentWaitTimeFilter));
      this.localAgentTeams = JSON.parse(JSON.stringify(this.localFilterMap.localAgentTeams));
      this.localAgentGroups = JSON.parse(JSON.stringify(this.localFilterMap.localAgentGroups));
      this.localAgents = JSON.parse(JSON.stringify(this.localFilterMap.localAgents));

      this.localFilterMap.searchType = this.searchType;
      this.localFilterMap.searchFor = this.searchFor;
      this.localFilterMap.sentBy = this.sentBy;
      this.localFilterMap.searchIn = this.searchIn;
      this.localFilterMap.searchKeyword = this.searchKeyword;

    },

    handleTimeRangeFilter(timeRangeFilter) {
      let fromValue = this.timeToMilliSecond(timeRangeFilter.fromValue);
      let toValue = this.timeToMilliSecond(timeRangeFilter.toValue);
      if((fromValue || fromValue === 0) && (toValue || toValue === 0)) {
        return (fromValue < toValue) ? {'fromValue': fromValue, 'toValue': toValue} : {'fromValue': toValue, 'toValue': fromValue};
      }
      else {
        return {'fromValue': fromValue, 'toValue': toValue}
      }
    },

    milliSecondToTimeFormat(obj, seconds) {
      obj.hh = '00';
      obj.mm = '00';
      obj.ss = '00';
      let hours = parseInt(seconds / 3600);
      hours = (hours > 99) ? 99 : hours; // set max hours as 99, ned to remove it after
      let formatedHours = (hours>9)?""+hours:"0"+hours;
      seconds = seconds % 3600;
      let minutes = parseInt( seconds / 60);
      let formatedMinutes = (minutes>9)?""+minutes:"0"+minutes;
      seconds = parseInt(seconds % 60);
      let formatedSeconds = (seconds>9)?""+seconds:"0"+seconds;
      obj.hh = formatedHours;
      obj.mm = formatedMinutes;
      obj.ss = formatedSeconds;
    },

    timeToMilliSecond(timeObj) {
      let milliSecond = null;

      if(timeObj && timeObj.hh == "" && timeObj.mm == "" && timeObj.ss == "") {
        return null;
      }
      else if(timeObj) {
        milliSecond = ((WyUtils.toInt(timeObj.hh, 0) * 60 * 60) + (WyUtils.toInt(timeObj.mm, 0) * 60) + WyUtils.toInt(timeObj.ss, 0)) * 1000;
      }
      return milliSecond;
    },

    applySearch(el, filterName="Direct Search Activation") {
      this.handleCreateTags();

      setTimeout(() => {
        document.querySelectorAll('.global-filter-picker-multiple-popper').forEach(el => {
          el.style.display = "none";
        })
        if(this.$refs.localAgentFilter && this.$refs.localAgentFilter.showPopper) {
          this.agentCancel();
        }
        if(this.$refs.allFilters && this.$refs.allFilters.showPopper) {
          this.cancelAllfilters();
        }
        if(this.$refs.contactReasonFilter && this.$refs.contactReasonFilter.visible) {
          this.$refs.contactReasonFilter.hide()
        }
        if(this.$refs.containmentFilter && this.$refs.containmentFilter.visible) {
          this.$refs.containmentFilter.hide()
        }
        if(this.$refs.responseNameFilter && this.$refs.responseNameFilter.visible) {
          this.$refs.responseNameFilter.hide()
        }
        if(this.$refs.relatedTopicsFilter && this.$refs.relatedTopicsFilter.visible) {
          this.$refs.relatedTopicsFilter.hide()
        }
        if(this.$refs.intentNameFilter && this.$refs.intentNameFilter.visible) {
          this.$refs.intentNameFilter.hide()
        }
        if(this.$refs.responseTimeFilter && this.$refs.responseTimeFilter.visible) {
          this.$refs.responseTimeFilter.hide()
        }
        if(this.$refs.handlingTimeFilter && this.$refs.handlingTimeFilter.visible) {
          this.$refs.handlingTimeFilter.hide()
        }
        if(this.$refs.sentimentFilter && this.$refs.sentimentFilter.visible) {
          this.$refs.sentimentFilter.hide()
        }
        if(this.$refs.feedbackFilter && this.$refs.feedbackFilter.visible) {
          this.$refs.feedbackFilter.hide()
        }
        if(this.$refs.handoffsFilter && this.$refs.handoffsFilter.visible) {
          this.$refs.handoffsFilter.hide()
        }
        //OC-1805
        if(this.$refs.besSignalsFilter && this.$refs.besSignalsFilter.visible) {
          this.$refs.besSignalsFilter.hide()
        }
        if(this.$refs.basSignalsFilter && this.$refs.basSignalsFilter.visible) {
          this.$refs.basSignalsFilter.hide()
        }
        //OC-1805
      }, 0);
      this.localSearchApplied = true;
      this.prepareFilters();
      this.transcriptFilters['action'] = 'search';
      if(el && el.hide) {
        el.hide();
      }

      if(this.$refs.localAgentTeamsDropdown) this.$refs.localAgentTeamsDropdown.closeDropdown();
      if(this.$refs.localAgentGroupsDropdown) this.$refs.localAgentGroupsDropdown.closeDropdown();
      if(this.$refs.localAgentsDropdown) this.$refs.localAgentsDropdown.closeDropdown();
      if(this.$refs.localAgentTeamsDropdownAllFilter) this.$refs.localAgentTeamsDropdown.closeDropdown();
      if(this.$refs.localAgentGroupsDropdownAllFilter) this.$refs.localAgentGroupsDropdown.closeDropdown();
      if(this.$refs.localAgentsDropdownAllFilter) this.$refs.localAgentsDropdown.closeDropdown();

      setTimeout(()=>{
        this.transcriptSearchResultsComponent.loadTopicConversations(1, false, filterName);
        this.appliedFilterCount = 0
        this.appliedSearchKeyword = this.searchKeyword!="";
        this.isSavedTranscriptResultSelected = this.savedTranscriptResult;

        const agentHandleTimeCondition = (typeof this.transcriptFilters.agentHandleTimeMillisMin != 'undefined' && this.transcriptFilters.agentHandleTimeMillisMin !== this.localFilters.agentHandlingTime.minAgentHandlingTime * 1000
          || typeof this.transcriptFilters.agentHandleTimeMillisMin == 'undefined' && this.localFilters.agentHandlingTime.minAgentHandlingTime * 1000 !== 0)
          || this.transcriptFilters.agentHandleTimeMillisMax !== this.localFilters.agentHandlingTime.maxAgentHandlingTime * 1000

        const agentResponseTimeCondition = (typeof this.transcriptFilters.agentResponseTimeMillisMin != 'undefined' && this.transcriptFilters.agentResponseTimeMillisMin !== this.localFilters.agentResponseTime.minAgentResponseTime * 1000
          || typeof this.transcriptFilters.agentResponseTimeMillisMin == 'undefined' && this.localFilters.agentResponseTime.minAgentResponseTime * 1000 !== 0)
          || this.transcriptFilters.agentResponseTimeMillisMax !== this.localFilters.agentResponseTime.maxAgentResponseTime * 1000

        if(this.transcriptFilters['agentGroups'] && this.checkArrayEqual(this.transcriptFilters['agentGroups'], this.defaultLocalFilterMap.localAgentGroups.value)) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
          this.localFilters.agent.updated = true;
        }
        if(this.transcriptFilters['agentTeams'] && this.checkArrayEqual(this.transcriptFilters['agentTeams'], this.defaultLocalFilterMap.localAgentTeams.value)) {
          this.appliedFilterCount  = this.appliedFilterCount + 1;
          this.localFilters.agent.updated = true;
        }
        if(this.transcriptFilters['agents'] && this.checkArrayEqual(this.transcriptFilters['agents'], this.defaultLocalFilterMap.localAgents.value)) {
          this.appliedFilterCount  = this.appliedFilterCount + 1;
          this.localFilters.agent.updated = true;
        }

        if((!this.transcriptFilters['agentTeams'] || (this.transcriptFilters['agentTeams'] && !this.checkArrayEqual(this.transcriptFilters['agentTeams'], this.defaultLocalFilterMap.localAgentTeams.value)))
        && (!this.transcriptFilters['agentGroups'] || (this.transcriptFilters['agentGroups'] && !this.checkArrayEqual(this.transcriptFilters['agentGroups'], this.defaultLocalFilterMap.localAgentGroups.value)))
        && (!this.transcriptFilters['agents']    || (this.transcriptFilters['agents'] && !this.checkArrayEqual(this.transcriptFilters['agents'], this.defaultLocalFilterMap.localAgents.value)))
        ){
          this.localFilters.agent.updated = false;
        }

        // agent handle time
        if (agentHandleTimeCondition) {
          this.localFilters.agentHandlingTime.updated = true;
          this.appliedFilterCount  = this.appliedFilterCount + 1
        } else {
          this.localFilters.agentHandlingTime.updated = false;
        }
        // agent response time
        if (agentResponseTimeCondition) {
          this.localFilters.agentResponseTime.updated = true;
          this.appliedFilterCount  = this.appliedFilterCount + 1
        } else {
          this.localFilters.agentResponseTime.updated = false;
        }
      }, 200)

      // close advanced filter (in case it's open)
      this.handleCloseAdvancedSearch();
    },

    applyExport() {
      if(this.transcriptSearchResultsComponent && this.transcriptSearchResultsComponent.applyExport) {
        this.transcriptSearchResultsComponent.applyExport();
      }
    },

    selectAllContactReasons() {
      if(this.isContactReasonSelectedAll) {
        this.filterdContactReasons.forEach(item => {
          if(!this.selectedContactReasons.includes(item.topicDisplayName)) {
            this.selectedContactReasons.push(item.topicDisplayName);
          }
        })
      }
      else {
        this.filterdContactReasons.forEach(item => {
          this.selectedContactReasons = this.selectedContactReasons.filter(f => f !== item.topicDisplayName)
        })
      }
    },

    selectAllResponseNames() {
      if(this.isResponseNameSelectedAll) {
        this.filteredResponseNames.forEach(item => {
          if(!this.selectedResponseNames.includes(item.responseName)) {
            this.selectedResponseNames.push(item.responseName);
          }
        })
      }
      else {
        this.filteredResponseNames.forEach(item => {
          this.selectedResponseNames = this.selectedResponseNames.filter(f => f !== item.responseName)
        })
      }
    },

    selectAllRelatedTopics() {
      if(this.isRelatedTopicSelectedAll) {
        this.filteredRelatedTopics.forEach(item => {
          if(!this.selectedRelatedTopics.includes(item.topicDisplayName)) {
            this.selectedRelatedTopics.push(item.topicDisplayName);
          }
        })
      }
      else {
        this.filteredRelatedTopics.forEach(item => {
          this.selectedRelatedTopics = this.selectedRelatedTopics.filter(f => f !== item.topicDisplayName)
        })
      }
    },

    selectAllIntentNames() {
      if(this.isIntentNameSelectedAll) {
        this.filteredIntentNames.forEach(item => {
          if(!this.selectedIntentNames.includes(item.intentName)) {
            this.selectedIntentNames.push(item.intentName);
          }
        })
      }
      else {
        this.filteredIntentNames.forEach(item => {
          this.selectedIntentNames = this.selectedIntentNames.filter(f => f !== item.intentName)
        })
      }
    },

    resetContactReasons() {
      // this.isSelectedAll = false;
      this.selectedContactReasons = [];
    },

    resetResponseName() {
      this.selectedResponseNames = [];
    },

    resetIntentNames() {
      this.selectedIntentNames = [];
    },

    resetRelatedTopics() {
      this.selectedRelatedTopics = [];
    },

    resetSentiment() {
      this.selectedSentiment = [];
    },

    resetFeedback() {
      // if(this.selectedFeedback.length > 0) {
      //   this.selectedBesSignals = this.selectedFeedback.includes('neg') ? this.selectedBesSignals.filter(x => x !== 'hasNegativeFeedbackSignal') : this.selectedBesSignals;
      //   this.selectedBasSignals = this.selectedFeedback.includes('neg') ? this.selectedBasSignals.filter(x => x !== 'hasNegativeFeedbackSignal') : this.selectedBasSignals;
      // }
      this.selectedFeedback = [];
    },

    resetContainment() {
      // if(this.selectedContainment.length > 0) {
      //   this.selectedBasSignals = this.selectedContainment.includes(['BotOnlyEscalated', 'BotToLC']) ? this.selectedBasSignals.filter(x => x !== 'hasLiveAgentEscalationSignal') : this.selectedBasSignals;
      // }
      this.selectedContainment = [];
    },

    resetBesSignals() {
      if(this.selectedBesSignals.length > 0) {
        this.selectedBasSignals = this.selectedBesSignals.includes('hasAbandonedByUserSignal') ? this.selectedBasSignals.filter(x => x !== 'hasAbandonedByUserSignal') : this.selectedBasSignals;
        this.selectedBasSignals = this.selectedBesSignals.includes('hasNegativeFeedbackSignal') ? this.selectedBasSignals.filter(x => x !== 'hasNegativeFeedbackSignal') : this.selectedBasSignals;
        // this.selectedFeedback = this.selectedBesSignals.includes('hasNegativeFeedbackSignal') ? this.selectedFeedback.filter(x => x !== 'neg') : this.selectedFeedback;
      }
      this.selectedBesSignals = [];
    },

    resetBasSignals() {
      if(this.selectedBasSignals.length > 0) {
        this.selectedBesSignals = this.selectedBasSignals.includes('hasAbandonedByUserSignal') ? this.selectedBesSignals.filter(x => x !== 'hasAbandonedByUserSignal') : this.selectedBesSignals;
        this.selectedBesSignals = this.selectedBasSignals.includes('hasNegativeFeedbackSignal') ? this.selectedBesSignals.filter(x => x !== 'hasNegativeFeedbackSignal') : this.selectedBesSignals;
        // this.selectedFeedback = this.selectedBasSignals.includes('hasNegativeFeedbackSignal') ? this.selectedFeedback.filter(x => x !== 'neg') : this.selectedFeedback;
        // this.selectedContainment = this.selectedBasSignals.includes('hasLiveAgentEscalationSignal') ? this.selectedContainment.filter(x => !['BotOnlyEscalated', 'BotToLC'].includes(x)) : this.selectedContainment;
      }
      this.selectedBasSignals = [];
    },

    resetResponseTimeRange() {
      this.responseTimeFilter = {}
      this.responseTimeFilter.fromValue = {};
      this.responseTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.responseTimeFilter.fromValue, this.localFilters.responseTime.minResponsetime);
      this.milliSecondToTimeFormat(this.responseTimeFilter.toValue, this.localFilters.responseTime.maxResponseTime);
    },

    resetHandlingTimeRange() {
      this.handlingTimeFilter = {}
      this.handlingTimeFilter.fromValue = {};
      this.handlingTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.handlingTimeFilter.fromValue, this.localFilters.handlingTime.minHandlingTime);
      this.milliSecondToTimeFormat(this.handlingTimeFilter.toValue, this.localFilters.handlingTime.maxHandlingTime);
    },

    resetHandoffs() {
      this.handOffsFilter.fromValue = this.localFilters.handOffs.minHandOffs;
      this.handOffsFilter.toValue = this.localFilters.handOffs.maxHandOffs;
    },

    resetAgentHandlingTimeRange() {
      this.agentHandlingTimeFilter = {}
      this.agentHandlingTimeFilter.fromValue = {};
      this.agentHandlingTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.agentHandlingTimeFilter.fromValue, this.localFilters.agentHandlingTime.minAgentHandlingTime);
      this.milliSecondToTimeFormat(this.agentHandlingTimeFilter.toValue, this.localFilters.agentHandlingTime.maxAgentHandlingTime);
    },

    resetAgentResponseTimeRange() {
      this.agentResponseTimeFilter = {}
      this.agentResponseTimeFilter.fromValue = {};
      this.agentResponseTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.agentResponseTimeFilter.fromValue, this.localFilters.agentResponseTime.minAgentResponseTime);
      this.milliSecondToTimeFormat(this.agentResponseTimeFilter.toValue, this.localFilters.agentResponseTime.maxAgentResponseTime);
    },

    resetAgentWaitTimeRange() {
      this.agentWaitTimeFilter = {}
      this.agentWaitTimeFilter.fromValue = {};
      this.agentWaitTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.agentWaitTimeFilter.fromValue, this.localFilters.agentWaitTime.minAgentWaitTime);
      this.milliSecondToTimeFormat(this.agentWaitTimeFilter.toValue, this.localFilters.agentWaitTime.maxAgentWaitTime);
    },

    resetAgents() {
      // this.resetAgentHandlingTimeRange();
      // this.resetAgentResponseTimeRange();
      // this.resetAgentWaitTimeRange();
      if((this.dataModel.filters.agentTeams.value.length == 0) && (this.dataModel.filters.agentGroups.value.length == 0)
      && (this.dataModel.filters.agents.value.length == 0)) {
        this.localAgentTeams = JSON.parse(JSON.stringify(this.dataModel.filters.agentTeams));
        this.localAgentTeams.label = this.localAgentTeams.label;
        this.localAgentTeams.isDisabled = (this.dataModel.filters.agentTeams.value.length !== 0);
        this.agentTeamsDataSource = JSON.parse(JSON.stringify(this.localAgentTeams.dataSource));
        this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
        this.localAgentGroups.label = this.localAgentGroups.label;
        this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
        this.agentGroupsDataSource = JSON.parse(JSON.stringify(this.localAgentGroups.dataSource));
        this.localAgents = JSON.parse(JSON.stringify(this.dataModel.filters.agents));
        this.localAgents.label = this.localAgents.label;
        this.localAgents.isDisabled = (this.dataModel.filters.agents.value.length !== 0);
        this.agentsDataSource = JSON.parse(JSON.stringify(this.localAgents.dataSource));
        this.refreshAgentFilters()
      }else {
        this.refreshAgentFilters()
        
        this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
        this.localAgentTeams.isDisabled = (this.dataModel.filters.agentTeams.value.length !== 0);

        this.localAgents.isDisabled = (this.dataModel.filters.agents.value.length !== 0);
      }
    },

    refreshAgentFilters() {
      this.localAgentTeams.isDisabled = (this.dataModel.filters.agentTeams.value.length !== 0);
      this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
      this.localAgents.isDisabled = (this.dataModel.filters.agents.value.length !== 0);

      this.localAgentTeams = JSON.parse(JSON.stringify(this.dataModel.filters.agentTeams));
      this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
      this.localAgents = JSON.parse(JSON.stringify(this.dataModel.filters.agents));

      let agentGroupsComponent = this.$refs.localAgentGroupsDropdown;
      let agentTeamsComponent = this.$refs.localAgentTeamsDropdown;
      let agentsComponent = this.$refs.localAgentsDropdown;
      if(!this.showAgentFilters) {
        agentGroupsComponent = this.$refs.localAgentGroupsDropdownAllFilter;
        agentTeamsComponent = this.$refs.localAgentTeamsDropdownAllFilter;
        agentsComponent = this.$refs.localAgentsDropdownAllFilter;
      }
      agentGroupsComponent.preSelectedFilters = this.dataModel.filters.agentGroups.value
      agentTeamsComponent.preSelectedFilters = this.dataModel.filters.agentTeams.value
      agentsComponent.preSelectedFilters = this.dataModel.filters.agents.value
      setTimeout(()=>{
        this.agentGroupsChangedCallback()
        this.agentTeamsChangedCallback()
        this.agentsChangedCallback()
      }, 100)
      
    },

    refreshAgentTeams() {
      let agentGroupsDS = this.dataModel.filters.agentGroups.dataSource;
      let agentGroupsValues = agentGroupsDS.map(item => item.key);
      this.agentGroupsDataSource.splice(1, this.agentGroupsDataSource.length);
      this.agentGroupsDataSource.push(...agentGroupsDS);
      this.localAgentGroups.value = this.localAgentGroups.value.filter(val => agentGroupsValues.includes(val));
      this.localAgentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');
      
      this.agentsDataSource = this.dataModel.filters.agents.dataSource;
      let agentsValues = this.agentsDataSource.map(item => item.key);
      this.localAgents.value = this.localAgents.value.filter(val => agentsValues.includes(val));
      this.localAgents.isEmpty = (this.agentsDataSource.length == 1 && this.agentsDataSource[0].key == 'all');
    },

    refreshAgentGroups() {
      
      this.agentTeamsDataSource = this.dataModel.filters.agentTeams.dataSource;
      let agentTeamsValues = this.agentTeamsDataSource.map(item => item.key);
      this.localAgentTeams.value = this.localAgentTeams.value.filter(val => agentTeamsValues.includes(val));
      this.localAgentTeams.isEmpty = (this.agentTeamsDataSource.length == 1 && this.agentTeamsDataSource[0].key == 'all');
      
      this.agentsDataSource = this.dataModel.filters.agents.dataSource;
      let agentsValues = this.agentsDataSource.map(item => item.key);
      this.localAgents.value = this.localAgents.value.filter(val => agentsValues.includes(val));
      this.localAgents.isEmpty = (this.agentsDataSource.length == 1 && this.agentsDataSource[0].key == 'all');
    },

    refreshAgents() {
      
      this.agentTeamsDataSource = this.dataModel.filters.agentTeams.dataSource;
      let agentTeamsValues = this.agentTeamsDataSource.map(item => item.key);
      this.localAgentTeams.value = this.localAgentTeams.value.filter(val => agentTeamsValues.includes(val));
      this.localAgentTeams.isEmpty = (this.agentTeamsDataSource.length == 1 && this.agentTeamsDataSource[0].key == 'all');
      let agentGroupsDS = this.dataModel.filters.agentGroups.dataSource;
      let agentGroupsValues = agentGroupsDS.map(item => item.key);
      this.agentGroupsDataSource.splice(1, this.agentGroupsDataSource.length);
      this.agentGroupsDataSource.push(...agentGroupsDS);
      this.localAgentGroups.value = this.localAgentGroups.value.filter(val => agentGroupsValues.includes(val));
      this.localAgentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');
    },

    onSearchFocus() {
      document.querySelector(".search").style.border = '1px solid #106FBC';
    },

    onSearchBlur() {
      if(document.activeElement == this.$refs.searchInput.$el.children[0]) {
        document.querySelector(".search").style.border = '1px #106FBC solid';
      }
      else {
        document.querySelector(".search").style.border = '1px #C9CCCF solid';
      }
    },

    onSearchForFocus() {
      const ref = this.$refs.advancedSearchFor
      if (ref) {
        ref.$el.style.border = '1px solid #106FBC';
      }
    },

    onSearchForBlur() {
      const ref = this.$refs.advancedSearchFor
      if (ref && document.activeElement != ref.$el.children[0]) {
        ref.$el.style.border = '1px solid #CAD2DA';
      }
    },

    onSearchHover() {
      const elInput = document.querySelector('.search .div-search-input input.el-input__inner');
      const elInputLeft = document.querySelector('.search .div-search-input .el-input');
      elInput.style.backgroundColor = '#f5f7fa';
      elInputLeft.style.backgroundColor = '#f5f7fa';
    },

    onSearchLeave() {
      const elInput = document.querySelector('.search .div-search-input input.el-input__inner');
      const elInputLeft = document.querySelector('.search .div-search-input .el-input');
      elInput.style.backgroundColor = '#fff';
      elInputLeft.style.backgroundColor = '#fff';
    },
        
    handleOpenAdvancedSearch() {
      this.$refs.advancedSearchTooltip.hide();
    },
    handleCloseAdvancedSearch() {
      this.showAdvancedSearchFilterSticky = false;
      this.showAdvancedSearchFilter = false;
    },

    handleCancelAdvancedSearch() {
      this.searchType = this.localFilterMap.searchType;
      // this.searchFor = this.localFilterMap.searchFor;
      // this.searchIn = this.localFilterMap.searchIn;
      this.sentBy = this.localFilterMap.sentBy;
      this.searchKeyword = this.localFilterMap.searchKeyword;

      this.handleCreateTags();

      this.handleCloseAdvancedSearch();
    },

    handleSetElInputWidth(widthSizePx) {
      const elInput = document.querySelector('.search .div-search-input input.el-input__inner');
      elInput.style.paddingLeft = `${widthSizePx}px`;

    },
    handleApplyAdvancedSearch() {
      this.handleCloseAdvancedSearch()
      if (this.searchKeyword != this.localFilterMap.searchKeyword 
        || this.localFilterMap.searchType != this.searchType
        || this.localFilterMap.sentBy != this.sentBy
      ) {
        this.applySearch();
      }
    },
    handleCreateTags() {
      // Check if filter wrapper exists
      let filterTagWrapper = this.$refs.searchInput.$el.querySelector('.advanced-search-filter-tag-wrapper');

      if (!filterTagWrapper) {
        filterTagWrapper  = document.createElement('div');
        filterTagWrapper.classList.add('advanced-search-filter-tag-wrapper');
        this.handleSetElInputWidth(8)
      }
      // const searchInTag = this.handleCreateSearchInTags(filterTagWrapper);
      // const searchForTag = this.handleCreateSearchForTags(filterTagWrapper);
      const sentByTag = this.handleCreateSentByTag(filterTagWrapper);

      // make sure that the searchInTag is always the first child
      // if (searchInTag) filterTagWrapper.insertBefore(searchInTag, filterTagWrapper.firstChild);
      // if (searchForTag) filterTagWrapper.appendChild(searchForTag);
      if (sentByTag) filterTagWrapper.appendChild(sentByTag);
      const searchInputRefEl = this.$refs.searchInput.$el;
      searchInputRefEl.insertBefore(filterTagWrapper, searchInputRefEl.firstChild);
    },
    handleCreateSearchInTags(filterTagWrapper) {
      const searchInFilter = this.searchInList.filter(item => this.searchIn.includes(item.key)).map(item => item.label);
      const ALL_OPTIONS_SELECTED = 3
      const NO_OPTIONS_SELECTED = 0
      if (searchInFilter.length === ALL_OPTIONS_SELECTED || searchInFilter.length === NO_OPTIONS_SELECTED) {
        // remove first tag (created from searchIn just to leave with searchFor tag)
        const wrapperLength = filterTagWrapper.children.length;
        if (wrapperLength >= 1) {
          filterTagWrapper.removeChild(filterTagWrapper.firstChild);
        }
        return
      }

      // remove the word "messages" in each element in the array except for the last element
      searchInFilter.forEach((item, index) => {
        if (index !== searchInFilter.length - 1) {
          searchInFilter[index] = item.replace(' messages', '');
        }
      });
      let searchInTag = filterTagWrapper.querySelector('.advanced-search-filter-tag-in');
      const isSearchInTagSameKey = searchInTag && searchInTag.getAttribute('data-key') === this.searchIn.join(',');
      if (searchInTag && isSearchInTagSameKey) {
        return; // do nothing
      } else if (searchInTag && !isSearchInTagSameKey) {
        filterTagWrapper.removeChild(searchInTag); // remove the existing tag
      }
      searchInTag = document.createElement('div');
      searchInTag.classList.add('advanced-search-filter-tag-in');
      searchInTag.textContent = `in: ${searchInFilter.map(item => item.toLowerCase()).join(', ')}`;
      searchInTag.setAttribute('data-key', this.searchIn.join(','));
      
      return searchInTag
    },
    handleCreateSearchForTags(filterTagWrapper) {
      const searchForFilter = this.searchForList.find(item => item.key === this.searchFor).label;      
      let searchForTag = filterTagWrapper.querySelector('.advanced-search-filter-tag-for');
      const isSearchForTagSameKey = searchForTag && searchForTag.getAttribute('data-key') === this.searchFor;

      if (!this.searchKeyword || this.searchType == '2') {
        if (searchForTag) filterTagWrapper.removeChild(searchForTag); // remove the existing tag
        return;
      }
      if (searchForTag && isSearchForTagSameKey) {
        return; // do nothing
      } else if ((searchForTag && !isSearchForTagSameKey)) {
        filterTagWrapper.removeChild(searchForTag); // remove the existing tag
      }
      searchForTag = document.createElement('div');
      searchForTag.classList.add('advanced-search-filter-tag-for');
      searchForTag.textContent = searchForFilter.toLowerCase();
      searchForTag.setAttribute('data-key', this.searchFor);
      return searchForTag
    },
    handleCreateSentByTag(filterTagWrapper) {
      const findLabel = this.sentByList.find(item => item.value === this.sentBy) && this.sentByList.find(item => item.value === this.sentBy).label;
      const sentByFilter = findLabel ? findLabel : this.sentByList[0].label;
      let sentByTag = filterTagWrapper.querySelector('.advanced-search-filter-tag-sent-by');      
      const isSentByTagSameKey = sentByTag && sentByTag.getAttribute('data-key') === this.sentBy;
      if (this.sentBy == '' || this.searchType == '2') {
        if (sentByTag) filterTagWrapper.removeChild(sentByTag); // remove the existing tag
        return;
      }
      if (sentByTag && isSentByTagSameKey) {
        return; // do nothing
      } else if ((sentByTag && !isSentByTagSameKey)) {
        filterTagWrapper.removeChild(sentByTag); // remove the existing tag
      }
      sentByTag = document.createElement('div');
      sentByTag.classList.add('advanced-search-filter-tag-sent-by');
      sentByTag.textContent = 'in: ' + sentByFilter;
      sentByTag.setAttribute('data-key', this.sentBy);
      return sentByTag
    },
    
    handleResetAllAdvancedSearch() {
      this.handleSetElInputWidth(37)
      
      this.searchKeyword = ''
      this.searchType = '1'
      this.searchFor = '1'
      this.sentBy = '';
      this.searchIn = ['1','2','3']
      this.removeAllSearchTags();
    },
    removeAllSearchTags() {
      this.handleSetElInputWidth(37)
      const filterTagWrapper = this.$refs.searchInput.$el.querySelector('.advanced-search-filter-tag-wrapper');
      if (filterTagWrapper) {
        filterTagWrapper.remove();
      }
    },
    handleClickOutsideOfPopover() {
      if (this.showAdvancedSearchFilterSticky) {
        this.showAdvancedSearchFilter = true
      } else {
        const filterChanged = this.checkAdvancedFilterChanges()
        if (filterChanged) {
          this.showAdvancedSearchFilter = false
          this.handleApplyAdvancedSearch();
        } else {
          this.handleCancelAdvancedSearch()
        }
      }
    },
    handleEllipsis(selectedItem) {
      if (!selectedItem) return ""
      
      const character_limit = 34;
      if (selectedItem.length > character_limit) {
        return selectedItem.substring(0, character_limit) + '...';
      }
      return selectedItem;
    }
  },

  mounted(){
    this.transcriptSearchResultsComponent = this.controller.$refs.transcriptSearchResults;
    if(this.$refs.contentEl) {
      this.$refs.contentEl.addEventListener("scroll", () => {
        if(this.$refs.localAgentsDropdownAllFilter) this.$refs.localAgentsDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentTeamsDropdownAllFilter) this.$refs.localAgentTeamsDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentGroupsDropdownAllFilter) this.$refs.localAgentGroupsDropdownAllFilter.closeDropdown();
        if(this.$refs.contactReasonFilterAllFilter)  this.handleChangeVisible(false, this.$refs.contactReasonFilterAllFilter);
        if(this.$refs.responseNameFilterAllFilter) this.handleChangeVisible(false, this.$refs.responseNameFilterAllFilter);
        if(this.$refs.relatedTopicFilterAllFilter) this.handleChangeVisible(false, this.$refs.relatedTopicFilterAllFilter);
        if(this.$refs.intentNameFilterAllFilter) this.handleChangeVisible(false, this.$refs.intentNameFilterAllFilter);
      });
    }
    if(this.$refs.agentFilterContent) {
      this.$refs.agentFilterContent.addEventListener("scroll", () => {
        if(this.$refs.localAgentGroupsDropdown) this.$refs.localAgentGroupsDropdown.closeDropdown();
        if(this.$refs.localAgentTeamsDropdown) this.$refs.localAgentTeamsDropdown.closeDropdown();
        if(this.$refs.localAgentsDropdown) this.$refs.localAgentsDropdown.closeDropdown();
      });
    }

    if((!this.contactReason || this.contactReason == '') && this.$refs.allFiltersCard) {
      this.$refs.allFiltersCard.parentElement.classList.remove('contact-reason-transcript')
    }

    if (this.companyHasLiveAgent) {
      this.containmentList = this.containmentList.filter(
        (list) => list.label !== CONTAINMENT_OPTIONS.LIVE_AGENT_REQUESTED
      );
    } else {
      this.containmentList = this.containmentList.filter(
        (list) =>
          list.label !== CONTAINMENT_OPTIONS.NOT_CONNECTED &&
          list.label !== CONTAINMENT_OPTIONS.LIVE_AGENT_CONNECTED
      );
    }

    // const searchInputRef = this.$refs.searchInput
    // if (searchInputRef) {
    //   searchInputRef.$el.addEventListener('click', this.handleSearchInputClick)
    // }

    // hide all inner dropdowns in advanced search when scroll
    // document.querySelector('.wy-analytics-interactions-transcript-search-dropdown-menu.search-input .body').addEventListener('scroll', () => {
    //   this.hideInnerDropdowns();
    // });

    // hide tooltip on tab switch
    document.addEventListener('visibilitychange', () => {
      const isAdvancedSearchIconFocused = document.activeElement.classList.contains('advanced-search-icon');
      if (isAdvancedSearchIconFocused) {
        document.activeElement.blur();
      }
    });

    /**
     * This logic allows el-popover to conditionally open and close on specific element.
     * Since we need the popover to stay open on $refs.searchInput click, 
     * and close on click everywhere else, we need to listen to this event.
     */
    this.$root.$on('fire-app-hide-popover-events', (e) => {
      const targetClassList = e && e.target && e.target.classList
      const isSearchInput = ['search-inp', 'el-input', 'el-input__inner'].some((className) => targetClassList.contains(className));
      if (isSearchInput) {
        this.showAdvancedSearchFilterSticky = true;
      } else {
        this.showAdvancedSearchFilterSticky = false;
      }
    });
  },
  created() {
     // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]();
    })

    try {
      if(!this.localAgentTeams || (this.dataModel.filters.agentTeams.value.length !== 0)) {
        this.localAgentTeams = JSON.parse(JSON.stringify(this.dataModel.filters.agentTeams));
        this.localAgentTeams.label = this.localAgentTeams.label;
        this.agentTeamsDataSource = JSON.parse(JSON.stringify(this.localAgentTeams.dataSource));
        this.dataModel.filters.agentTeams.isEmpty = (this.agentTeamsDataSource.length == 1 && this.agentTeamsDataSource[0].key == 'all');
        this.localFilterMap.localAgentTeams = JSON.parse(JSON.stringify(this.localAgentTeams));
      }
      if(!this.localAgentGroups || (this.dataModel.filters.agentGroups.value.length !== 0)) {
        this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
        this.localAgentGroups.label = this.localAgentGroups.label;
        this.agentGroupsDataSource = JSON.parse(JSON.stringify(this.localAgentGroups.dataSource));
        this.dataModel.filters.agentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');
        this.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.localAgentGroups));
      }
      if(!this.localAgents || (this.dataModel.filters.agents.value.length !== 0)) {
        this.localAgents = JSON.parse(JSON.stringify(this.dataModel.filters.agents));
        this.localAgents.label = this.localAgents.label;
        this.agentsDataSource = JSON.parse(JSON.stringify(this.localAgents.dataSource));
        this.dataModel.filters.agents.isEmpty = (this.agentsDataSource.length == 1 && this.agentsDataSource[0].key == 'all');
        this.localFilterMap.localAgents = JSON.parse(JSON.stringify(this.localAgents));
      }
    }
    catch(e) {
      console.log(e);
    }
  },

  beforeDestroy(){
    if(this.$refs.allFilters && this.$refs.allFilters.$el.firstChild) {
      this.$refs.allFilters.$el.firstChild.removeEventListener("scroll", () => {
        if(this.$refs.localAgentsDropdownAllFilter) this.$refs.localAgentsDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentTeamsDropdownAllFilter) this.$refs.localAgentTeamsDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentGroupsDropdownAllFilter) this.$refs.localAgentGroupsDropdownAllFilter.closeDropdown();
        if(this.$refs.contactReasonFilterAllFilter)  this.handleChangeVisible(false, this.$refs.contactReasonFilterAllFilter)
        if(this.$refs.responseNameFilterAllFilter) this.handleChangeVisible(false, this.$refs.responseNameFilterAllFilter)
        if(this.$refs.relatedTopicFilterAllFilter) this.handleChangeVisible(false, this.$refs.relatedTopicFilterAllFilter)
        if(this.$refs.intentNameFilterAllFilter) this.handleChangeVisible(false, this.$refs.intentNameFilterAllFilter)
      });
    }
  }
});
</script>

<style lang="scss">
.transcript-search-advanced-search-dropdown {
  .el-select-dropdown__item {
    font-size: 14px;
  }
  .el-select-dropdown__wrap.el-scrollbar__wrap {
    display: block !important;
  }

  .el-select-dropdown__list {
    padding: 0px !important;
    height: 80px !important;
    .el-select-dropdown__item {
      height: 40px;
      color: var(--site-font-tertiary-color) !important;
      font-weight: 400;
      font-size: 14.22px;
      border-radius: 4px;
      display: flex;
      align-items: center;
    }
    .el-select-dropdown__item.selected {
      color: var(--site-font-tertiary-color) !important; // use #1A55AD?
      font-weight: 500 !important;
      background: #E8F1FF;
    }
  }

}
.wy-analytics-interactions-transcript-search-filters {
  min-width: 892px;
  .advanced-search-filter-tag-wrapper {
    margin-left: 40px;
    display: flex;
    align-items: center;
    gap: 6px;

    .advanced-search-filter-tag-sent-by,
    .advanced-search-filter-tag-for,
    .advanced-search-filter-tag-in 
    {
      padding: 1px 8px 0px 8px;
      background-color: #E8F1FF;
      color: rgb(16, 111, 188);
      font-size: 14px;
      line-height: 40px;
      font-weight: 500;
      border-radius: 5px;
      height: 22px;
      display: flex;
      align-items: center;
      min-width: max-content;
      width: max-content;
    }
    
    // .advanced-search-filter-tag-for {
    //   padding: 0px 14px;
    //   background-color: #E8F1FF;
    //   color: rgb(16, 111, 188);
    //   font-size: 14px;
    //   line-height: 40px;
    //   font-weight: 500;
    //   border-radius: 5px;
    //   height: 22px;
    //   display: flex;
    //   align-items: center;
    //   min-width: max-content;
    // }

    // .advanced-search-filter-tag-in {
    //   padding: 0px 14px;
    //   background-color: #E8F1FF;
    //   color: rgb(16, 111, 188);
    //   font-size: 14px;
    //   line-height: 40px;
    //   font-weight: 500;
    //   border-radius: 5px;
    //   height: 22px;
    //   display: flex;
    //   align-items: center;
    //   min-width: max-content;
    // }
    
  }
  .transcript-detail-export-btn {
    // background: transparent;
    box-sizing: border-box;
    border-radius: 5px;
    // border: 1px solid #CAD2DA !important;
    padding: 6px 15px 9px 11px !important;
    width: 90px;
    font-size: 16px !important;
    height: 39px;
    font-weight: 500 !important;
    // color: var(--site-font-tertiary-color) !important;
    background: var(--site-button-secondary-btn-background-primary-color);
    color: var(--site-button-secondary-btn-text-primary-color);
    border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
    float: right;
    &:hover{
      background-color: #F4F6F8;
    }
  }
  .transcript-detail-export-btn:hover {
    border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
    background-color: var(--site-button-secondary-btn-hover-background-primary-color) !important;
    border-radius: 5px;
    color: var(--site-button-secondary-btn-text-primary-color) !important;
  }
  .transcript-detail-export-btn:active {
    background-color: var(--site-button-secondary-btn-pressed-background-primary-color) !important;
  }
  .transcript-detail-export-btn:focus {
    border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
    border-radius: 5px;
    color: var(--site-button-secondary-btn-text-primary-color) !important;
  }
  .search-button {
    background-color: white;
    border-radius: 8px;
    width: 38px;
    height: 23px;
    text-align: center;
    margin-top: 2px;
    margin-left: 3px;
    padding: 3px 0px 0px 0px;
    font-size: 22px;
    position: absolute;
    z-index: 100;
    background: transparent;
    color: #5C5F62;
    cursor: pointer;
  }
  .search-section {
    display: flex;
    
    .search {
      display: flex;
      align-items: center;
      // margin-top: 10px;
      /* padding-top: 15px; */
      height: 30px;
      // width: 463px;
      width: 510px;
      border-radius: 32px;

      border-radius: 32px;
      margin-bottom: 5px;
      // border: 1px transparent solid;
      border: 1px solid #C9CCCF;



      .search-inp {
        // width: 315px !important;
        width: 100%;
        height: 30px;
        padding-bottom: 0px;
        input.el-input__inner {
          height: 30px;
          font-size: 14px;
          width: 100%;
          padding-right: 40px;

          &:hover{
            background-color: #F4F6F8;
          }
        }
      }
      .el-input:focus-within {
        outline-width: 0 !important;
      }
      .el-input__inner::placeholder {
        color: #828E9A !important;
        font-size: 14.22px;
      }
      .el-input__inner:hover{
        background: #F4F6F8;

      }

      .div-search-input {
        width: 510px;
        height: 30px;
        display: inline-block;
        position: relative;
        margin-right: 1px;
        input.el-input__inner {
          border-width: 0px 0px 0px 0px !important;
          height: 30px;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
          font-size: 15px;
          padding-left: 37px;
          padding-right: 60px;
          border-right: 0px;
          padding-bottom: 2px;
        }
        .el-input__icon {
          line-height: 25px;
          font-weight: bolder;
          background-image: url('../../../assets/icons/icon_search.svg');
          background-repeat: no-repeat;
          background-size: 16px 16px;
          background-position-y: 8px;
          background-position-x: 5px;
        }
        .el-input__icon:before {
          content: '';
        }
        .el-input{
          border: 35px;
          // height: 30px;
          font-size: 14px;
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          border-bottom-left-radius: 20px;
          border-top-left-radius: 20px;
          width: 508px;
          height: 28px;
          padding-left: 0px;
          padding-bottom: 0px;
        }
        .fa-times-circle {
          position: relative;
          left: 454px;
          bottom: 26px;
          color: #606060;
          font-size: 16px;
          cursor: pointer;
          height: 20px;
          width: 24px;
          padding: 5px 3px 0px 6px;
        }
      }
      .advanced-search-icon {
        position: relative;
        margin-left: -26px;
        // top: -23px;
        // left: 549px;
        cursor: pointer;
        background-image: url('../../../assets/icons/icon_transcripts_advanced_search.svg');
        background-size: 68%;
        width: 24px;
        height: 18px;
        border-radius: 4px;
        background-repeat: no-repeat;
      }
    }
    .export-div {
      margin-left: auto;
      .export-text {
        padding-right: 5px;
      }
      .export-icon {
        background: var(--icon_action_export);
        height: 17px;
        width: 13px;
        position: relative;
        top: 2px;
        height: 17px;
        width: 13px;
        display: inline-block;
        background-repeat: no-repeat;
      }
      .el-button {
        margin-right: 0px !important;
        height: 35px;
        margin-top: 11px;
        padding-top: 7px;
        font-size: 15px;
        background: var(--site-button-secondary-btn-background-primary-color);
        color: var(--site-button-secondary-btn-text-primary-color);
        border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
      }
    }
  }
  .last-verticalLine{
    border-right: 1px solid rgb(189, 185, 185);
    border-right: 1px solid #CAD2DA;

    font-size: 24px;
    display: inline;
    margin-right: 10px;
    position: relative;
    top: 3px;
  }
  .verticalLine {
    border-right: 1px solid rgb(189, 185, 185);
    border-right: 1px solid #CAD2DA;

    font-size: 24px;
    display: inline;
    margin-right: 10px;
    position: relative;
    top: 3px;
  }
  .save-transcript-btn {
    // margin-top: 6px;
    margin-right: 10px;
    float: left;
    background-image: url('../../../assets/icons/icon_golden_star.svg');
    background-size: 8%;
    background-repeat: no-repeat;
    background-position-x: 10px;
    background-position-y: 6px;
    span.text {
      padding-left: 20px;
      font-size: 15px;
      font-weight: 400 !important;
      color: #202223;
    }
  }
  .save-transcript-btn:hover {
    // background-color: #FFF;
    background-color: #F4F6F8;
    //color: #214586;
    color: var(--site-font-tertiary-color);
  }
  .save-transcript-btn:focus {
    background-color: #FFF;
    color: #214586;
  }

  .save-transcript-btn.saved-transcript-filter {
    //background-color: #214586;
    background-color: #E8F1FF;
    //color: #FFF;
    color: var(--site-font-tertiary-color);
    border: 1px solid #106FBC;
  }
  .save-transcript-btn.saved-transcript-filter:hover {
    // background-color: #214586;
    // color: #FFF;
    background-color: #F4F6F8;
    color: var(--site-font-tertiary-color);
  }
  .save-transcript-btn.saved-transcript-filter:focus {
    background-color: var(--site-button-save-button-background-primary-color);
    color: var(--site-font-tertiary-color);
  }

  .fa-times-circle {
    position: relative;
    left: 523px;
    bottom: 28px;
    color: #000000;
    font-size: 18px;
    cursor: pointer;
  }

  .el-button .el-icon--right {
    font-weight: 600;
    pointer-events: none;
  }
  .el-button .el-icon--right.hide {
    color: #E8F1FF;
  }

  // .el-input:focus-within {
  //   border: 1px solid #106FBC !important;
  // }
  .el-input {
    // border: 1px solid #C9CCCF !important;
    font-size: 20px;
    overflow: hidden;
    border-top-right-radius: 35px;
    border-bottom-right-radius: 35px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    width: 146px;
    height: 28px;
    padding-left: 0;
    display: flex;
    padding-bottom: 0;
    align-items: center;
    .el-input__icon {
      line-height: 29px !important;
      color: #606060;
    }
    .el-input__inner {
      padding-right: 30px;
      border-width: 0 0 0 0!important;
      border-bottom-right-radius: 20px;
      border-top-right-radius: 20px;
      height: 30px;
      font-size: 14px;
      padding: 10px;
      color: var(--site-font-tertiary-color);
      font-weight: 400;
      padding-bottom: 10px !important;
    }
  }

  .el-button {
    margin-top: 12px;
    margin-right: 5px;
    border: 1px solid #CAD2DA;
    font-size: 15px;
    font-weight: 400 !important;
    color: #202223;
    height: 30px;
    padding: 5px 12px 5px 12px;
  }
  .el-button.with-border {
    border: 1px solid #106FBC;
  }
  .el-button:focus,.el-button:active {
    // background-color: #214586;
    // color: #FFF;
    // background-color: #E8F1FF;
    background-color: #FFF;
    color: #202223;
    // border: 1px solid #106FBC;
  }
  .el-button:focus {
    background-color: #FFF;
    // color: #202223;
    // border: 1px solid #106FBC;
  }
  .el-button:hover, .el-button.is-disabled:hover{
    // background-color: #F4F6F8;
    background-color: #F4F6F8;
    color: #202223;
  }
  .el-dropdown .el-button:focus{
    // background-color: #FFF;
    // color: #214586;
    // background-color: #E8F1FF;
    background-color: #FFF;
    color: var(--site-font-tertiary-color);
  }
  .el-dropdown .other.el-button--default.selected:hover {
    // background-color: #F4F6F8;
    background-color: #E8F1FF;
    color: var(--site-font-tertiary-color);
  }
  .dropdown .other.el-button--default.selected {
    background-color: #E8F1FF;
    border: 1px solid #106FBC;
    color: var(--site-font-tertiary-color);
  }
  button.el-button.other.el-button--default.selected {
    background-color: #E8F1FF;
    border: 1px solid #106FBC;
    color: var(--site-font-tertiary-color);
    .reset-btn-icon {
      display: block !important;
      width: 25px;
      height: 25px;
      left: 60px;
      top: 7px;
      float: left;
      background-image: url('../../../assets/icons/icon_blue_close.svg');
      background-size: 57%;
      background-repeat: no-repeat;
      background-position-x: 0px;
      background-position-y: 0px;
      position: absolute;
    }
    .contact-reason.reset-btn-icon {
      left: 157px;
      top: 21px;
    }
    .response-names.reset-btn-icon {
      left: 138px;
      top: 21px;
    }
    .related-topics.reset-btn-icon {
      left: 118px;
      top: 21px;
    }
    .intent-names.reset-btn-icon {
      left: 110px;
      top: 21px;
    }
    .agent.reset-btn-icon {
      left: 108px;
      top: 20px;
    }
    .bes-bas.reset-btn-icon {
      left: 106px;
      top: 21px;
    }
    .containment.reset-btn-icon {
      left: 105px;
      top: 20px;
    }
    .handling-time.reset-btn-icon {
      left: 138px;
      top: 20px;
    }
    .response-time.reset-btn-icon {
      left: 170px;
      top: 20px;
    }
    .sentiment.reset-btn-icon {
      left: 90px;
      top: 21px;
    }
    .feedback.reset-btn-icon {
      left: 90px;
      top: 21px;
    }
    .hand-offs.reset-btn-icon {
      left: 83px;
      top: 21px;
    }
    .all-filters.reset-btn-icon {
      left: 104px;
      top: 20px;
    }
  }
  // .reset-btn-icon.selected {
  //   display: block !important;
  //   width: 25px;
  //   height: 25px;
  //   left: 135px;
  //   top: 6px;
  //   float: left;
  //   background-image: url('../../../assets/icons/icon_blue_close.svg');
  //   background-size: 57%;
  //   background-repeat: no-repeat;
  //   background-position-x: 0px;
  //   background-position-y: 0px;
  //   position: absolute;
  // }

  .fa-chevron-right {
    font-size: 12px;
    color: #214586;
  }
}
.allFilters-popover.interactions.trending-topic-detail .horizontal-line .handoffs{
  width: 446px !important;
  border-radius: 5px;
  div.min-hint {
    right: 52px;
  }
  div.max-hint {
    left: 14px;
  }
  .time{
    display: flex;
    justify-content: space-evenly;
    width: 81%;
    margin-left: 34px;

    .el-input-number {
      margin-right: 2px;
      min-width: 16.5em !important;
      right: 11px;
      height: 33px !important;
      .el-input__inner{
        height: 33px !important;
        text-align: left;
      }

      .el-input-number.is-controls-right .el-input-number__increase {
        background-image: url('../../../assets/icons/icon_handoff_arrow_up.svg')
      }
      .el-icon-arrow-:before {
        display: none;
      }
    }
    .el-input-number.is-controls-right .el-input-number__increase, .el-input-number.is-controls-right .el-input-number__decrease {
      border-bottom: 1px solid #DCDFE6;
      background: #E4E5E7;
      width: 22px;
      border-radius: 2px;
      height: 12px;
      margin-top: 2px;
      margin-bottom: 2px;
      margin-right: 2px;
    }
    input.display-time {
      border: 1px solid #d2d2d2;
      width: 14em !important;
      height: 2.6em;
      position: relative;
      border-radius: 4px;
      right: 9px;
      left: -2px;
      color: var(--site-font-tertiary-color);
      margin-right: 0px;
      padding: 0.3em 0.5em;
      font-size: 1em;
    }
    input.display-time:focus {
      outline: none;
      border: 2px solid #106FBC;
      border-radius: 4px;
    }
  }
  .horizontal-line{
    margin-bottom: -20px;
    margin-top: 25px;
  }
  .card-bottom-part{
    max-width: 421px !important;
    padding: 10px 0px 10px 25px !important;
  }
}
.interactions-advanced-wrapper {
  padding: 0px !important;
  margin: 0px;
  border-radius: 10px;
  top: 285px !important;
  left: 345px !important;
  width: 625px;

  .agents-cancel-btn {
    color: #1C4DB2;
    margin-bottom: 10px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 400;
    padding: 8px 9px;
    border-radius: 5px;
    position: relative;
    right: 8px;

    &:hover{
      background: #F4F6F8;
    }
  }
  .agent-title{
    color: var(--site-font-secondary-color);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    padding: 20px;
    border-bottom: 1px solid #CAD2DA;
  }
  .btn-select-all {
    float: right;
    padding-right: 0px;
    margin-top: -1px;
    cursor: pointer;
    font-size: 14px;
    background-image: var(--icon_close_popup);
    background-repeat: no-repeat;
    height: 36px;
    width: 36px;
  }
  .horizontal-line {
    border-bottom: none !important;
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin-bottom: 0px;
    
    .title-inside {
      padding: 10px 10px 10px 10px;
      font-size: 14.22px;
    }

    .agent-groups {
      padding: 0px 10px;
      .el-input ::placeholder {
        color: #606266;
        opacity: 1; /* Firefox */
      }

      .el-input ::-ms-input-placeholder { /* Edge 12 -18 */
        color: #606266;
      }
      .el-input.is-disabled ::placeholder {
        color: #C0C4CC;
        opacity: 1; /* Firefox */
      }

      .el-input.is-disabled ::-ms-input-placeholder { /* Edge 12 -18 */
        color: #C0C4CC;
      }
      .find-results-section {
        position: relative;
        span.prefix-label {
          position: absolute;
          left: 28px;
          top: 11px;
          font-size: 14px;
        }
        span.prefix-label.disabled {
          color: #C0C4CC;
        }
        .el-input--suffix .el-input__inner {
          padding-left: 22px;
          height: 28px !important;
        }
      }
    }

    .div-search-dropdown {
      // border-bottom: 1px solid #CAD2DA;
      padding-bottom: 20px;
    }

    .el-dropdown-menu__item {
      display: flex;
      margin-top: 18px;
      flex-direction: column;
    }

    .el-input.is-disabled {
      .el-input__inner {
        color: #C0C4CC;
        cursor: not-allowed !important;
      }
      .el-select__caret {
        cursor: not-allowed !important;
      }

    }
  }
  .card-bottom-part {
    display: flex;
    border-top: 1px solid #CAD2DA;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 13px 15px 15px 25px;
    // max-width: 420px;
    .transcript-search-cancel-btn {
      padding: 10px 16px;
      color: var(--site-button-cancel-btn-primary-color);
      border: 1px solid var(--site-button-cancel-btn-primary-border-color);
      border-radius: 5px;
      height: 17px;
      width: 45px;
      position: relative;
      left: -23px;
      font-size: 14.22px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .transcript-search-apply-btn {
      padding: 10px 16px;
      cursor: pointer;
      margin-left: 10px;
      margin-right: 13px;
      background: var(--site-button-primary-btn-background-primary-color);
      color: var(--site-button-primary-btn-text-primary-color);
      border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
      border-radius: 5px;
      position: relative;
      left: 0px;
      height: 17px;
      width: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14.22px;
    }
  }

  .el-select>.el-input {
    display: block;
    border: 1px solid #CAD2DA;
    border-radius: 5px;
    padding: 1px;
    width: 322px;
    margin-left: 10px;
    color: var(--site-font-tertiary-color);
    font-size: 14px;
    line-height: 36px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    border: none;
    outline: 0;
    padding: 0;
    margin-left: 15px;
    color: #666;
    font-size: 14px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 28px;
    /* line-height: 36px; */
    background-color: transparent;
  }
  .el-input__suffix {
    right: 5px;
    -webkit-transition: all .3s;
    transition: all .3s;
  }
  .el-input__prefix, .el-input__suffix {
    position: absolute;
    top: 0;
    -webkit-transition: all .3s;
    height: 100%;
    color: #C0C4CC;
    text-align: center;
  }
  .el-select .el-input .el-select__caret {
    color: #C0C4CC;
    font-size: 14px;
    -webkit-transition: -webkit-transform .3s;
    transition: -webkit-transform .3s;
    transition: transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    -webkit-transform: rotateZ(180deg);
    transform: rotateZ(180deg);
    cursor: pointer;
    /* line-height: 36px; */
  }
}

.interaction-transcript-search-filter-dropdown {
  height: 95px;
  .el-scrollbar {
    height: 95px;
  }
}
.interaction-transcript-search-filter-dropdown-sent-by {
  height: 130px;
  .el-scrollbar {
    height: 130px;
  }
}

.interaction-transcript-search-filter-dropdown, 
.interaction-transcript-search-filter-dropdown-sent-by 
{
  min-width: 325px !important;
  width: 325px;
  left: 344px;
  .el-scrollbar__bar.is-horizontal {
    height: 0px;
  }
  .el-scrollbar__wrap {
    width: fit-content;
    margin-right: 0px !important;
    overflow-x: hidden;
  }
  .el-select-dropdown__list {
    width: 324px;
    margin-top: 10px;
    .el-select-dropdown__item {
      margin: 0px 20px;
    }
  }
  .el-select-dropdown__item.selected {
      color: #006FE7;
      font-weight: 400;
  }
  .el-select-dropdown__item:hover {
    background: #E8F3FF !important;
    // color: #006FE7;
    border-radius: 5px !important;
  }
}

.wy-analytics-interactions-transcript-search-dropdown-menu.search-input {
  width: 530px !important;
  border-radius: none !important;
  padding: 10px 20px !important;
  color: #202223 !important;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 14.22px;
  line-height: 17px;
  margin-top: 0px !important;
  left: 320px !important;
  box-shadow: 0px 30px 50px 0px rgba(0, 0, 0, 0.20);
  background: white;
  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 400;
  }
  .body {
    width: 97%;
    .el-input__inner {
      height: 35px !important;
    }
    .el-input__icon {
      line-height: 0px !important;
      font-weight: 1000 !important;
      color: #5C5F62 !important
    }
    .sub-heading {
      font-size: 14px;
      font-weight: 400;
      padding: 10px 0px;
  
    }
    .disabled {
      color: #828E9A;
    }
    .sub-items {
      padding: 10px 0px;
    }
    .left-option {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .dropdown-wrapper {
        flex: 1;
        .el-select {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
          // change bg color of the disabled search for dropdown
          .el-input.is-disabled .el-input__inner {
            background: white !important;
          }
        }
      }
      
      .search-wrapper {
        flex: 3;
        border: 1px solid #CAD2DA;
        border-left: none;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        margin-left: 2px;
        height: 39px;
        display: flex;
        align-items: center;
        // change bg color of the disabled search for input
        .el-input.is-disabled .el-input__inner {
          background: white !important;
        }
        .el-input__inner {
          border: none;
          padding-left: 13px !important;
        }
      }
      // .search-for-inp {
      //   input.el-input__inner {
      //     font-size: 14px;
      //     &:hover{
      //       background-color: #F4F6F8;
      //     }
      //   }
      //   .el-input:focus-within {
      //     outline-width: 0 !important;
      //   }
      //   .el-input__inner::placeholder {
      //     color: #828E9A !important;
      //     font-size: 14.22px;
      //   }
      //   .el-input__inner:hover{
      //     background: #F4F6F8;
      //   }
      // }
    }
    .el-checkbox-group {
      display: flex;
      align-items: center;
      justify-content: space-between;
  
      .el-checkbox {
        margin: 0px !important;
        margin-right: 4px !important;
        .el-checkbox__inner {
          font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
          border: 2px solid var(--primary-checkbox-button-border-color) !important;
          width: 16px;
          height: 16px;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: var(--primary-checkbox-button-check-color) !important;
          border-color: var(--primary-checkbox-button-checked-border-color) !important;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner::after {
          left: 5px;
          top: 2px;
        }
        .el-checkbox__input.is-disabled .el-checkbox__inner {
          background-color: var(--primary-checkbox-button-disabled-background-color) !important;
          border-color: var(--primary-checkbox-button-disabled-border-color) !important;
        }
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-between;
    .actions {
      display: flex;
    }
    .actions-btn {
      padding: 10px 16px;
      color: #202223;
      border: 1px solid #CAD2DA;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: normal;
      font-size: 14px;
    }
    .reset {
      border: none;
      margin-left: -14px;
    }
    .clear-btn {
      position: relative;
      font-size: 14px;
      font-weight: normal;
      margin-right: 14px;
      color: var(--site-button-cancel-btn-primary-color);
      border: 0px solid var(--site-button-cancel-btn-primary-border-color);
      padding: 0px;
      .char {
        margin-left: auto;
      }
    }

    .apply-btn {
      position: relative;
      color: var(--site-font-chart-color);
      background: var(--site-button-primary-btn-background-primary-color);
      color: var(--site-button-primary-btn-text-primary-color);
      border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
      border-radius: 4px;
      width: 80px;
    }
    .apply-btn:hover {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }
    .apply-btn:active {
      background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
    }
    .apply-btn:focus {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      // background-color: unset;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }
    .disabled {
      background: #E4E5E7;
      color: #C9CCCF;
    }
  }
  .divider {
    margin: 10px -20px;
    border-bottom: 1px solid #CAD2DA;
  }
  .el-select {
    width: 100%;
    border: none;
    border: 1px solid #CAD2DA;
    border-radius: 5px;
    padding: 2px 0px;
    .el-input__inner {
      padding-left: 10px !important;
      border: none;
    }
    .el-input__inner:hover {
      border: none;
    } 
    // change the color of placeholder
    .el-input__inner::placeholder {
      color: #202223 !important;
      font-size: 14.22px;
    }
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.handoffs {
  width: 446px !important;
  border-radius: 5px;
  .time{
    display: flex;
    justify-content: space-evenly;
    .el-input-number {
      margin-right: 2px;
      min-width: 11.5em !important;
      right: 11px;
      height: 33px !important;
      .el-input__inner{
        height: 33px !important;
        text-align: left;
      }

      .el-icon-arrow-up {
        color: transparent;
      }
      .el-icon-arrow-up:before {
        background-image: url('../../../assets/icons/icon_handoff_arrow_up.svg');
        background-position-x: 16px;
      }
      .el-icon-arrow-down {
        color: transparent;
      }
      .el-icon-arrow-down:before {
        background-image: url('../../../assets/icons/icon_handoff_arrow_down.svg');
        background-position-x: 16px;
      }
    }
    .el-input-number.is-controls-right .el-input-number__increase, .el-input-number.is-controls-right .el-input-number__decrease {
      border-bottom: 1px solid #DCDFE6;
      background: #E4E5E7;
      width: 21px;
      border-radius: 2px;
      height: 11.5px;
      margin-top: 2px;
      margin-bottom: 2px;
      margin-right: 2px;
    }
    input.display-time {
      border: 1px solid #d2d2d2;
      width: 14em !important;
      height: 2.6em;
      position: relative;
      border-radius: 4px;
      right: 9px;
      left: -2px;
      color: #C9CCCF;
      margin-right: 0px;
      padding: 0.3em 0.5em;
      font-size: 1em;
    }
    input.display-time:focus {
      outline: none;
      border: 2px solid #106FBC;
      border-radius: 4px;
    }
  }
  .horizontal-line{
    margin-bottom: -20px;
    margin-top: 25px;
  }
  .card-bottom-part{
    max-width: 419px !important;
    padding: 10px 0px 10px 25px !important;
  }
  .cus-msg-card .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 162px !important;
  }
}
.time {
  .hours li {
    // border-left: 1px solid #CCC;
    border-right: 1px solid #CCC;
  }
  ul.minutes li {
    border-left: 1px solid #CCC;
    border-right: 1px solid #CCC;
  }
  ul.seconds li {
    border-left: 1px solid #CCC;
    border-right: 1px solid #CCC;
  }
}
.allFilters-popover.interactions.trending-topic-detail .horizontal-line .handle-time .time {
  width: 100% !important;
}
.allFilters-popover.interactions.trending-topic-detail .horizontal-line .handle-time .time, .allFilters-popover.interactions.trending-topic-detail .horizontal-line .response-time .time{
  // width: 81%;
  // justify-content: space-evenly;

  // margin-left: -20px !important;
 
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  // margin-top: 8px;
  // margin-left: 0px !important;
  // margin-bottom: 6px !important;
  .dropdown-btn{
    display: none;
  }
}
.allFilters-popover.interactions.trending-topic-detail .horizontal-line .agent-response-time .time {
  width: 100% !important;
}
.allFilters-popover.interactions.trending-topic-detail .horizontal-line .agent-response-time .time, .allFilters-popover.interactions.trending-topic-detail .horizontal-line .response-time .time{
  // width: 81%;
  // justify-content: space-evenly;

  // margin-left: -20px !important;
 
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  // margin-top: 8px;
  // margin-left: 0px !important;
  // margin-bottom: 6px !important;
  .dropdown-btn{
    display: none;
  }
}
.allFilters-popover.interactions.trending-topic-detail .horizontal-line .handoffs .time{
  .el-icon-arrow-up {
    color: transparent;
  }
  .el-icon-arrow-up:before {
    background-image: url('../../../assets/icons/icon_handoff_arrow_up.svg');
    background-position-x: 16px;
  }
  .el-icon-arrow-down {
    color: transparent;
  }
  .el-icon-arrow-down:before {
    background-image: url('../../../assets/icons/icon_handoff_arrow_down.svg');
    background-position-x: 16px;
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.handling-time .time input.display-time {
  left: -14px !important;
}

.wy-analytics-interactions-transcript-search-dropdown-menu.response-time .time input.display-time {
  left: -14px !important;
}

.wy-analytics-interactions-transcript-search-dropdown-menu .time {
  margin-left: 14px !important;
}
.wy-analytics-interactions-transcript-search-dropdown-menu.handling-time.time {
  margin-left: 0px !important;
  width: 300px !important;
}
.wy-analytics-interactions-transcript-search-dropdown-menu.handling-time {
  .time .dropdown {
    left: -12px !important;
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.handling-time, .wy-analytics-interactions-transcript-search-dropdown-menu.response-time, .allFilters-popover.interactions.trending-topic-detail .horizontal-line .handle-time, .allFilters-popover.interactions.trending-topic-detail .horizontal-line .response-time{
  width: 476px !important;
  // border-radius: 5px;

  .cus-msg-card .card-bottom-part .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 162px !important;
  }

  .time{
    width: 81%;
    // margin-left: 12px;
    display: flex;
    // justify-content: space-evenly;
    .vue__time-picker {
      width: 11em !important;
      margin-right: 2px;
      min-width: 13.5em !important;
      // right: 11px;
      right: 0px;
      .controls{
        align-items: center;
        .clear-btn {
          color: #5C5F62;
        }
      }
      .dropdown{
        width: 14em !important;
        height: 17em !important;
        top: calc(2.2em + 7px) !important;
        .select-list{
          width: 14em !important;
          height: 17em !important;
        }
        ul li:not([disabled]).active {
          background: #E8F1FF;
          color: var(--site-font-tertiary-color);
        }
        ul li {
          line-height: 40px;
        }
        .hint {
          font-size: 14px;
          color: var(--site-font-tertiary-color) !important;
        }
        ul{
          &::-webkit-scrollbar {
            background-color: white !important;
            width: 15px !important;
          }
          &::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: #CAD2DA !important;
            border-radius: 50px !important;
          }
        }
      }
    }
    input.display-time {
      border: 1px solid #d2d2d2;
      width: 14em !important;
      height: 2.6em;
      position: relative;
      border-radius: 4px;
      right: 9px;
      left: -2px;
      color: var(--site-font-tertiary-color);
      margin-right: 0px;
      padding: 0.3em 0.5em;
      font-size: 1em;
    }
    input.display-time:focus {
      outline: none;
      border: 2px solid #106FBC;
      border-radius: 4px;
    }

    .clear-btn {
      right: 17px !important;
    }
    // .vue__time-picker .dropdown {
    //   left: -12px;
    // }
  }
  .horizontal-line{
    margin-bottom: -20px;
    margin-top: 25px;
    padding-left: 17px;
    width: 90%;
  }
  .card-bottom-part{
    max-width: 550px !important;
    padding: 10px 0px 10px 25px !important;
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.handling-time, .wy-analytics-interactions-transcript-search-dropdown-menu.response-time{
  .time{
    // width: 93% !important;
  }
  .cus-msg-card .card-bottom-part .clear-btn {
    right: -82px !important;
  }
}
.allFilters-popover.interactions.trending-topic-detail .horizontal-line .containment, .allFilters-popover.interactions.trending-topic-detail .horizontal-line .sentiment{
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
}
.allFilters-popover.interactions.trending-topic-detail .horizontal-line .containment, .allFilters-popover.interactions.trending-topic-detail .horizontal-line .feedback{
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
}

.wy-analytics-interactions-transcript-search-dropdown-menu.contact-reasons, .all-filters-contact-reasons {
  .check-box-section {
    .el-loading-mask {
      bottom: 12px;
      background-color: #FFF;

      .el-loading-spinner {
        top: 35%;
        background: var(--site-loading-icon);

        background-repeat: no-repeat;
        background-size: 18px;
        background-position: center;

        .circular {
          display: inline-block;
          width: 65px;
          height: 65px;
        }
      }

      .el-loading-spinner .path {
        -webkit-animation: loading-dash 2s ease-in-out infinite;
        animation: loading-dash 2s ease-in-out infinite;
        stroke-dasharray: 90, 150;
        stroke-dashoffset: 0;
        stroke-width: 2.5 !important;
        stroke: #0C2837 !important;
        stroke-linecap: round;

      }
    }
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.contact-reasons, 
.wy-analytics-interactions-transcript-search-dropdown-menu.containment,
.wy-analytics-interactions-transcript-search-dropdown-menu.response-names,
.wy-analytics-interactions-transcript-search-dropdown-menu.intent-names, 
.wy-analytics-interactions-transcript-search-dropdown-menu.related-topics 
{
  width: 620px !important;
  border-radius: 5px;
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--primary-checkbox-button-check-color);
    border-color: var(--primary-checkbox-button-checked-border-color) !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.sentiment{
  width: 446px !important;
  border-radius: 5px;
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--primary-checkbox-button-check-color);
    border-color: var(--primary-checkbox-button-checked-border-color) !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }
  .cus-msg-card .card-bottom-part {
    max-width: 406px;
  }
  .cus-msg-card .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 150px !important;
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.feedback{
  width: 446px !important;
  border-radius: 5px;
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--primary-checkbox-button-check-color);
    border-color: var(--primary-checkbox-button-checked-border-color) !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }
  .cus-msg-card .card-bottom-part {
    max-width: 406px;
  }
  .cus-msg-card .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 150px !important;
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.agents {
  // height: 368px !important;
  width: 364px !important;
  border-radius: 5px;
  // left: 708px !important;
  .el-select .el-input .el-select__caret {
    color: #5C5F62 !important;
  }
  .btn-select-all {
    float: right;
    padding-right: 0px;
    margin-top: -1px;
    cursor: pointer;
    font-size: 14px;
    background-image: var(--icon_close_popup);
    background-repeat: no-repeat;
    height: 36px;
    width: 36px;
  }

  .cus-msg-card .card-bottom-part .clear-btn {
    position: relative;
    top: 4px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: -40px;
    .clear-filter-text {
      left: 0px;
    }
  }
  .cus-msg-card .card-bottom-part .transcript-search-cancel-btn {
    position: relative;
    left: -12px;
    top: 3px;
  }

  .cus-msg-card .card-bottom-part .transcript-search-apply-btn {
    left: 2px;
    top: 2px;
  }

  .horizontal-line {
    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background: #CAD2DA !important;
      border-radius: 50px !important;
    }
  }
  .agent-time-filter {
    .flex {
      padding-top: 12px;
    }
    div.min-hint {
      right: 56px;
    }
    div.max-hint {
      left: -76px;
    }
    .agent-time-title {
      margin-top: 16px;
      margin-left: 20px;
      font-size: 14px;
      color: #202223;
    }
    .time{
      display: flex;
      margin-top: 8px;
      margin-left: 29px !important;
      margin-bottom: 6px !important;
      .vue__time-picker {
        width: 11em !important;
        margin-right: 2px;
        min-width: 13.5em !important;
        right: 11px;
        .controls{
          align-items: center;
          .clear-btn {
            color: #5C5F62;
          }
        }
        .dropdown{
          width: 14em !important;
          height: 17em !important;
          top: calc(2.2em + 15px) !important;
          .select-list{
            width: 14em !important;
            height: 17em !important;
          }
          ul li:not([disabled]).active {
            background: #E8F1FF;
            color: #2A2E32;
          }
          ul li {
            line-height: 40px;
          }
          .hint {
            font-size: 14px;
            color: #2A2E32 !important;
          }
          ul{
            &::-webkit-scrollbar {
              background-color: white !important;
              width: 15px !important;
            }
            &::-webkit-scrollbar-thumb{
              border-radius: 10px;
              background: #CAD2DA !important;
              border-radius: 50px !important;
            }
          }
        }
      }
      input.display-time {
        border: 1px solid #CAD2DA;
        width: 14em !important;
        height: 3.2em;
        position: relative;
        border-radius: 4px;
        right: 9px;
        left: -2px;
        color: #2A2E32;
        margin-right: 0px;
        padding: 0.3em 0.5em;
        font-size: 1em;
      }
      input.display-time:focus {
        outline: none;
        border: 2px solid #106FBC;
        border-radius: 4px;
      }
    }
    .flex {
      left: 0px;
    }
    .clear-btn {
        position: relative;
        bottom: -6px;
        right: 8px;
        // right: 174px;
        font-size: 14.22px;
        color: #106FBC;
        border: none !important;
        padding: 0px;
        .char {
          margin-left: auto;
        }
    }
    .invalid-time-range {
      background: #F1D3D5;
      background-image: url("../../../assets/icons/icon_red_stop.svg");
      background-repeat: no-repeat;
      background-size: 14px;
      background-position-x: 10px;
      background-position-y: center;
      font-size: 13px;
      color: #59333E;
      border-radius: 5px;
      width: 245px;
      padding: 10px 0 10px 32px;
      line-height: 1;
      z-index: 1;
    }
  }
  .card-bottom-part {
    max-width: 441px !important;
  }
}

.wy-analytics-interactions-transcript-search-dropdown-menu {
  margin-top: 15px !important;
  box-shadow: 5px 5px 6px #00000029;
  border: 1px solid #F4F6F8 !important;
  border-radius: 10px;
  // .agents {
  //   width: 620px !important;
  //   border-radius: 5px;

  //   .btn-select-all {
  //     float: right;
  //     padding-right: 0px;
  //     margin-top: -1px;
  //     cursor: pointer;
  //     font-size: 14px;
  //     background-image: var(--icon_close_popup);
  //     background-repeat: no-repeat;
  //     height: 36px;
  //     width: 36px;
  //   }
  // }
  .contact-reasons, .containment {
    width: 620px !important;
    border-radius: 5px;
  }
  .el-checkbox{
    margin-top: 25px !important;
  }
  .title{
    margin-top: 0px !important;
  }
  .flex{
    display: flex;
    justify-content: space-around;
    position: relative;
    bottom: 14px;
    left: 12px;
    margin-bottom: 22px !important;
    .min-hint{
      position: relative;
      right: 74px;
      font-size: 14px;
      color: #4B5158;
    }
    .max-hint{
      position: relative;
      right: 75px;
      font-size: 14px;
      color: #4B5158;
    }
  }
  .cus-msg-card.handoffs .flex{
    .min-hint{
      position: relative;
      right: 76px;
      font-size: 14px;
      color: #4B5158;
    }
    .max-hint{
      position: relative;
      right: 76px;
      font-size: 14px;
      color: #4B5158;
    }
  }
  .top-part-flex{
    display: flex;
    justify-content: space-around;
    position: relative;
    bottom: 14px;
    right: 27px;
    width: 100%;
    margin-bottom: -35px !important;
  }
  .containment {
    /* vertical-align: top; */
    position: relative;
    bottom: 15px;
  }
  .cancel-text{
    font-size: 14px;
  }
  .cus-msg-card.handling-time,.cus-msg-card.response-time,.cus-msg-card.handoffs {
    .filter-header {
      .invalid-time-range {
        position: absolute;
        background: #F1D3D5;
        background-image: url("../../../assets/icons/icon_red_stop.svg");
        background-repeat: no-repeat;
        background-size: 14px;
        background-position-x: 10px;
        background-position-y: center;
        font-size: 13px;
        color: #59333E;
        border-radius: 5px;
        width: 245px;
        padding: 10px 0 10px 32px;
        line-height: 1;
        z-index: 1;
        top: 0px;
      }
    }
    .horizontal-line {
      .time {
        .el-input-number.el-input-number--mini {
          border: 2px solid transparent;
        }
        .el-input-number.el-input-number--mini.has-error {
          border: 2px solid #E6494C;
          outline: unset;
          border-radius: 7px;
        }
        .el-input-number.el-input-number--mini.is-focused {
          border: 2px solid #106FBC;
          outline: unset;
          border-radius: 4px !important;
        }
      }
    }
    .clear-btn {
      position: relative;
      bottom: -1px;
      right: 8px;
      // right: 174px;
      font-size: 14.22px;
      color: var(--site-button-cancel-btn-primary-color);
      border: 1px solid var(--site-button-cancel-btn-primary-border-color);
      padding: 0px;
      .char {
        margin-left: auto;
        color: #5C5F62;
      }
    }
    .dropdown-btn{
      display: none;
    }
    .el-input-number__increase:hover {
      color: #214586;
    }
  }

  .cus-msg-card.handoffs {
    .invalid-time-range {
      width: 262px !important;
    }
  }
  .clear-filter-text{
    position: relative;
    left: 0px;
    font-weight: normal;
    font-size: 14px;
  }
  .all-filter-top-title{
    color:#214586;
    font-size: 15px;
    font-weight: bold;
    // margin-top: 40px;
  }
  .other {
    color: #214586;
    background-color: #fff;
    border-color: #214586;
    height: 35px;
    margin-top: 35px;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }

  .all-filter-top-two-title {
    margin-top: 30px;
    font-size: 14.22px;
    color: #202223;
    .filter-title{
      font-size: 14.22px;
      color: #202223;
    }
  }

  .dash {
    padding: 0px 0px;
    color: #CAD2DA;
    font-size: 25px;
    position: relative;
    right: 11px;
  }
  // .reset-btn{
  //   cursor: pointer;
  // }

  .text {
    font-size: 16px;
  }
  span.contact-reason-dropdown-text {
    position: relative;
    bottom: 4px;
    right: 33px;
    color: #647B86;
    font-weight: normal;
    font-size: 15px;
  }
  .el-icon--right {
    margin-left: 5px;
    position: relative;
    left: 35px;
    bottom: 4px;
    color: #5C5F62;
  }
  span.max-hint {
    position: relative;
    right: 32px;
    font-size: 14px;
    color: #4B5158;
  }
  label.el-checkbox.checkbox.containment-checkbox {
    position: relative;
    right: 25px;
  }
  span.max-hint.last-max-hint {
    position: relative;
    right: 90px;
  }
  .reset-btn{
    text-decoration: underline;
    color: var(--site-font-primary-color);
    font-size: 15px;
    align-self: left;
    left: -40px;
    position: relative;
    cursor: pointer;
  }
  button.el-button.contact-reasons-dropdown.el-button--default.is-plain.el-dropdown-selfdefine {
    border-radius: 4px;
    width: 100%;
    height: 31px;
  }
  span.reset-btn.handoff-reset {
  left: -46px !important;
  position: relative;
  }
  .contact-reasons, .agent-filters {
    position: relative;
    left: 24px;
  }
  .all-filter-header{
    position: relative;
    left: 23px;
    color: var(--site-font-primary-color);
    font-size: 15px;
    align-content:left;
    font-weight: bold;
  }
  .cus-msg-card.all-filter-card {
    width: 374px;
  }
  .cus-msg-card {
    overflow: visible;
    width: 100%;
    left: 10px;
    top: 230px;
    background: #ffffff;
    border: 1px solid #f4f4f4;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-top: -15px;
    margin-bottom: -15px;
    .search-button {
      background-color: white;
      border-radius: 8px;
      width: 38px;
      height: 23px;
      text-align: center;
      margin-top: 5px;
      margin-left: 17px;
      padding: 3px 0px 0px 0px;
      font-size: 22px;
      position: absolute;
      z-index: 100;
      background: transparent;
      color: #5C5F62;
      cursor: pointer;
    }

    .card-bottom-part {
      display: flex;
      width: 100%;
      border-top: 1px solid #CAD2DA;
      justify-content: space-between;
      padding: 13px 15px 15px 25px;
      max-width: 450px !important;
      button.el-button.submit-btn.el-button--default.is-round {
        margin-left: auto;
        padding: 5px 15px;
      }
      span {
        cursor: pointer;
      }
      .transcript-search-cancel-btn {
        padding: 10px 16px;
        color: var(--site-button-cancel-btn-primary-color);
        border: 1px solid var(--site-button-cancel-btn-primary-border-color);
        border-radius: 5px;
        height: 17px;
        width: 45px;
        position: relative;
        left: -23px;
        font-size: 14.22px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .transcript-search-apply-btn {
        padding: 10px 16px;
        cursor: pointer;
        margin-left: 10px;
        margin-right: 13px;
        background: var(--site-button-primary-btn-background-primary-color);
        color: var(--site-button-primary-btn-text-primary-color);
        border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
        border-radius: 5px;
        position: relative;
        left: -8px;
        height: 17px;
        width: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14.22px;
      }
      .transcript-search-apply-btn:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .transcript-search-apply-btn:active {
        background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
      }
      .transcript-search-apply-btn:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .transcript-search-apply-btn.disabled {
        opacity: 0.5 !important;
        pointer-events: none;
      }
      .wrapper {
        cursor: not-allowed;
      }
    }

    .horizontal-line .el-checkbox-group {
      height: 105px;
      overflow-y: auto;
      .el-checkbox__input {
        line-height: 1.5;
      }
    }
  }

  // .cus-msg-card .agents {
  //   overflow: hidden;
  //   width: 343px;
  //   left: 10px;
  //   top: 230px;
  //   padding: 5px 20px 20px 25px;
  //   background: #ffffff;
  //   border: 1px solid #f4f4f4;
  //   box-sizing: border-box;
  //   box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  //   border-radius: 10px;
  //   margin-top: -15px;
  //   margin-bottom: -15px;

  //   .card-bottom-part {
  //     display: flex;
  //     width: 100%;
  //     border-top: 1px solid #CAD2DA;
  //     button.el-button.submit-btn.el-button--default.is-round {
  //       margin-left: auto;
  //       padding: 5px 15px;
  //     }
  //     span {
  //       cursor: pointer;
  //     }
  //   }

  //   .horizontal-line .el-checkbox-group {
  //     height: 105px;
  //     overflow-y: auto;
  //     .el-checkbox__input {
  //       line-height: 1.5;
  //     }
  //   }
  // }

  .time-picker > input {
    width: 25px;
  }
  .card-bottom-part {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #CAD2DA;
    padding-top: 33px;
  }
  .checkbox {
    display: block;
  }
  .vue__time-picker .dropdown {
    position: absolute;
    z-index: 5;
    top: calc(2.2em + 2px);
    left: 0;
    background: rgb(255, 255, 255);
    box-shadow: 0 1px 6px rgba(0,0,0,0.15);
    width: 10em;
    height: 6em;
    overflow: hidden;
    border-radius: 5px;
    font-weight: normal;

    .select-list {
      height: 6em;
    }
  }
  .vue__time-picker .controls .char {
    display: inline;
    color: #5C5F62;
  }
  .submit-btn {
    background: #214586;
    border: 2px solid #214586;
    box-sizing: border-box;
    border-radius: 35px;
    color: white;
  }

  .min-time,
  .max-time {
    position: relative;
    right: 10px;
  }

  .el-input[data-v-6d227d34] {
    width: 65px;
  }

  .hf-time {
    width: 65px;
    height: 25px;
  }

  .horizontal-line {
    margin-bottom: 6px;
    margin-right: 0px;
    padding-bottom: 10px;

    .min-handling-time-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-handling-time-label {
      margin-left: 126px;
      font-size: 12px;
    }
    .min-response-time-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-response-time-label {
      margin-left: 126px;
      font-size: 12px;
    }
    .min-handoffs-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-handoffs-label {
      margin-left: 126px;
      font-size: 12px;
    }
  }

  .horizontal-line-senti{
    margin-bottom: 6px;
    margin-right: -21px;
    padding-bottom: 0px;
  }
  .horizontal-line > input {
    margin-left: 25px;
  }
  .check-box-section {
    height: 236px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 50px !important;
    }
  }
  .check-box-section .checkbox-first-row {
    margin-left: 16px;
    padding-bottom: 2px !important;
  }
  .el-checkbox {
    color: var(--site-font-primary-color);
    margin-left: 16px;
    margin-bottom: 0px;
    margin-left: 25px;
    margin-right: 25px !important;
    display: flex;
    flex-direction: row;
    align-items: center;

    .el-checkbox__label {
      outline: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-checkbox__input {
      vertical-align: baseline;
      top: 0px;
    }
  }
  span.el-checkbox__inner:hover {
    // box-shadow: unset;
    -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow);
    box-shadow: var(--primary-checkbox-button-hover-box-shadow);
  }
  .el-checkbox.is-checked .el-checkbox__label {
    color: var(--site-font-primary-color) !important;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: var(--site-font-primary-color) !important;
  }

  .reg-inp {
    background: #ffffff;
    border: 1px solid #c0c0c0;
    box-sizing: border-box;
    border-radius: 4px;
    margin-left: 38px;
    margin-bottom: 15px;
    padding: 5px 0px 5px 15px;
  }
  .no-matching-data-text{
    display: flex;
    justify-content: center;
  }

  .time-hf {
    padding-left: 25px;
  }
  .min-time[data-v-6d227d34],
  .max-time[data-v-6d227d34] {
    width: 35 !important;
  }

  .time {
    margin-left: 25px;
    margin-bottom:20px;
  }
  .dash {
    padding: 0px 5px;
  }
  .cus-msg-card .filter-section.mutiple-select-section .el-dropdown-menu__item {
    .filter-title {
      color: var(--site-interaction-primary-font-color) !important;
    }
  }
  .cus-msg-card .filter-section.mutiple-select-section .el-dropdown-menu__item:hover {
    color: var(--site-interaction-primary-font-color) !important;
  }
  
  .el-dropdown-menu__item {
    max-width: 70%;
    display: inline-block;
    padding: 0px 17px;
    margin-bottom: 17px;
    list-style: none;
    line-height: 36px;
    margin: 0;
    font-size: 14px;
    color: var(--site-font-primary-color);
    cursor: pointer;
    outline: 0;
  }
  .el-select {
    width: 330px;
    position: relative;
  }
}

.wy-analytics-interactions-transcript-search-dropdown-menu.agents .cus-msg-card .horizontal-line .el-select__input {
  color: var(--site-font-tertiary-color) !important;
  font-size: 14px;
}

.wy-analytics-interactions-transcript-search-dropdown-menu.agents {
    margin-top: 24px !important;
    padding: 0px;
    box-shadow: none;
    margin-bottom: 8px;
  .horizontal-line .el-checkbox-group {
    height: fit-content;
  }
  .card-bottom-part {
    width: 323px !important;
  }
}

.wy-analytics-interactions-transcript-search-dropdown-menu.containment {
  margin-top: 15px!important;
  max-width: 446px;
  .card-bottom-part {
    max-width: 406px;
  }
  .horizontal-line .el-checkbox-group {
    height: fit-content;
  }
  .horizontal-line .signal-flex {
    display: flex;
    align-items: center;
    gap: 6px;

    .signal-icon {
      height: 20px;
      width: 20px;
    }
  }
  .cus-msg-card .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 162px;
  }
  .el-checkbox {
    display: flex;
    align-items: center;
    .el-checkbox__input {
      line-height: normal !important;
    }
  }
}

.wy-analytics-interactions-transcript-search-dropdown-menu.selected-cus-msg {
  margin-top: 0px !important;
  left: 315px !important;
  .el-radio {
    display: flex;
    margin-left: 25px;
    margin-bottom: 10px;
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #214586;
      background: #214586;
    }
    .el-radio__input.is-checked+.el-radio__label {
      color: #214586;
    }
    .el-radio__inner:hover {
      border-color: #214586;
    }
  }

}
    .filter-header{
      color: var(--site-font-secondary-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 20px;
      font-weight: 400;
      padding: 20px 13px 20px 20px;
      border-bottom: 1px solid #CAD2DA;
      .btn-select-all {
        float: right;
        padding-right: 0px;
        margin-top: -5px;
        cursor: pointer;
        font-size: 14px;
        background-image: var(--icon_close_popup);
        background-repeat: no-repeat;
        height: 36px;
        width: 36px;
      }
    }

.wy-analytics-interactions-transcript-search-dropdown-menu.agents {
  .cus-msg-card {
    .filter-header{
      color: var(--site-font-secondary-color);
      margin-bottom: 10px !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 14px;
      font-weight: 500 !important;
    }
    .agents-cancel-btn{
      color: #1C4DB2;
      margin-bottom: 10px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-weight: 400;
      padding: 8px 9px;
      border-radius: 5px;
      position: relative;
      right: 8px;

      &:hover{
        background: #F4F6F8;
      }
    }
    .agent-title{
      color: var(--site-font-secondary-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 20px;
      font-weight: 400;
      padding: 20px;
      border-bottom: 1px solid #CAD2DA;
    }
    .horizontal-line {
      border-bottom: none !important;
      width: 100%;
      height: 314px;
      overflow: auto;
      margin-bottom: 0px;
      padding-left: 10px;
      
      // .agents {
      //   margin-bottom: 25px !important;
      // }
      .el-dropdown-menu__item {
        display: flex;
        margin-top: 18px;
        flex-direction: column;
      }
      .el-input {
        border: 1px solid #CAD2DA;
        border-radius: 5px;
        padding: 1px;

      }
      .el-input__inner {
        border: none !important;
      }
      .el-select__input {
        margin-left: -2px;
      }
      .el-select__input::placeholder {
        color: #828E9A;
      }
      .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: transparent !important;
        color: var(--site-font-secondary-color) !important;
      }
      .el-tag.el-tag--info {
        background-color: #F2F3F3;
        border-color: #F2F3F3;
        color: var(--site-font-tertiary-color);
        font-size: 14px;
        max-width: 211px !important;
        width: fit-content;
        margin-left: -2px !important;
        padding-left: 5px !important;
        padding-right: 9px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .el-select__tags {
        margin-left: 9px !important;
      }
      .el-tag.el-tag--info .el-tag__close {
        color: #909399;
        display: none;
      }
    }
    .el-input {
      width: 93% !important;
    }
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.agents .cus-msg-card .horizontal-line .el-input__inner {
    // &:hover{
    //   background: #F4F6F8;
    // }
}

.el-checkbox__input.is-disabled .el-checkbox__inner {
  border: 1px solid var(--primary-checkbox-button-disabled-border-color) !important;
}
.el-checkbox__input.is-disabled .el-checkbox__inner:hover {
  box-shadow: unset !important;
}

.allFilters-popover.interactions.trending-topic-detail .horizontal-line .containment {
  .el-checkbox__input.is-disabled .el-checkbox__inner {
    border: 1px solid var(--primary-checkbox-button-disabled-border-color) !important;
  }
  .el-checkbox__input.is-disabled .el-checkbox__inner:hover {
    box-shadow: unset !important;
  }
}

.wy-analytics-interactions-transcript-search-dropdown-menu.intent-names {
  .reset-btn-icon {
    position: relative;
    
  }
}
.wy-analytics-interactions-transcript-search-dropdown-menu.contact-reasons,
.wy-analytics-interactions-transcript-search-dropdown-menu.response-names, 
.wy-analytics-interactions-transcript-search-dropdown-menu.intent-names, 
.wy-analytics-interactions-transcript-search-dropdown-menu.related-topics
{
  width: 620px !important;
  .cus-msg-card {
    .horizontal-line {
      margin-right: 0px;
      margin-left: 0px;
      padding-right: 5px;
      margin-bottom: 0px;
      padding-top: 25px;
      padding-bottom: 0px;
      overflow: hidden;
      border-top: 1px solid #CAD2DA;
      .reg-inp {
        background: #ffffff;
        border: 1px solid #CAD2DA;
        box-sizing: border-box;
        border-radius: 4px;
        height: 36px;
        margin-left: 15px !important;
        margin-bottom: 15px;
        padding: 5px 28px 5px 39px;
        width: 575px;
      }
    }
    .card-bottom-part {
      max-width: 582px;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
      .actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .contact-reason-label {
      display: inline-block;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 20px;
      color: var(--site-font-secondary-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 20px;
      font-weight: 400;
    }

    .btn-select-all {
      float: right;
      padding-right: 20px;
      margin-top: 12px;
      cursor: pointer;
      font-size: 14px;
      background-image: var(--icon_close_popup);
      background-repeat: no-repeat;
      height: 36px;
      width: 36px;
    }
    .input-hight-light {
      background-color: #E8F1FF !important;
    }

    .fa-times-circle {
      position: relative;
      left: -25px;
      bottom: -1px;
      color: #214586;
      font-size: 16px;
      cursor: pointer;
    }
    .el-checkbox__inner {
      border: 2px solid var(--primary-checkbox-button-border-color) !important;
    }
    .horizontal-line .el-checkbox-group {
      height: fit-content;
      // overflow-y: auto;
      width: 100%;

      &::-webkit-scrollbar {
        background-color: transparent !important;
        width: 8px !important;
      }
      &::-webkit-scrollbar-thumb{
        background: #CAD2DA !important;
        border-radius: 5px;
      }

      .el-checkbox {
        color: var(--site-font-primary-color);
        margin-bottom: 23px;
        margin-left: 15px;
        margin-right: 15px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        .el-checkbox__label {
          // max-width: 230px;
          width: 95%;
          .display-topic-name {
            display: inline-block;
            outline: none;
            max-width: 473px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .topic-number {
            float: right;
          }
        }
      }
      .el-checkbox__inner {
        top: 0px;
        width: 16px;
        height: 16px;
      }
    }
  }
  .clear-btn {
    padding: 10px 16px;
    // color: #202223;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    border-radius: 5px;
    height: 17px;
    width: 45px;
    font-size: 14.22px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .apply-btn {
    padding: 10px 16px;
    cursor: pointer;
    margin-left: 10px;
    margin-right: 13px;
    background: var(--site-button-primary-btn-background-primary-color);
    color: var(--site-button-primary-btn-text-primary-color);
    border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14.22px;
    font-weight: 400;
  }
  .apply-btn:hover {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }
  .apply-btn:active {
    background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
  }
  .apply-btn:focus {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    // background-color: unset;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }

  .card-bottom-part {
    padding-top: 16px;
  }
}

.wy-analytics-interactions-transcript-search-dropdown-menu.localAgentFilter {
  .cus-msg-card {
    .horizontal-line {
      margin-right: 0px;
      margin-left: 0px;
      border: 1px #e7e6e6 solid;
      padding-top: 10px;
      padding-bottom: 0px;
      border-radius: 10px;
      overflow: hidden;
      .reg-inp {
        background: #ffffff;
        border: 1px solid #c0c0c0;
        box-sizing: border-box;
        border-radius: 4px;
        margin-left: 15px !important;
        margin-bottom: 15px;
        padding: 5px 28px 5px 39px;
        width: 265px;
      }
    }
    .contact-reason-label {
      display: inline-block;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .btn-select-all {
      float: right;
      margin-top: 12px;
      cursor: pointer;
      font-size: 14px;
      text-decoration: underline;
      background-image: var(--icon_close_popup);
      background-repeat: no-repeat;
      height: 36px;
      width: 36px;
    }
    .fa-times-circle {
      position: relative;
      left: 258px;
      bottom: 37px;
      color: #214586;
      font-size: 16px;
      cursor: pointer;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: var(--site-font-primary-color);
    }
    .horizontal-line .el-checkbox-group {
      height: 305px !important;
      overflow-y: auto;
      width: 295px;

      .el-checkbox {
        color: var(--site-font-primary-color);
        margin-bottom: 10px;
        margin-left: 15px;
        margin-right: 15px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        .el-checkbox__label {
          max-width: 230px;
          width: 95%;
          .display-topic-name {
            display: inline-block;
            outline: none;
            max-width: 180px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .topic-number {
            float: right;
          }
        }
      }
      .el-checkbox__inner {
        top: 0px;
      }
    }
  }
}

.allFilters-popover.interactions.trending-topic-detail {
  width: 464px !important;
  // width: 338px !important;
  overflow: hidden;
  // width: 343px;
  left: 10px;
  // top: 368px !important;
  margin-top: 10px !important;
  padding: 0px !important;
  background: #ffffff;
  box-sizing: border-box;
  // box-shadow: 5px 5px 6px #00000029;
  border: 1px solid #F4F6F8 !important;
  border-radius: 24px;
  margin-top: 0px;
  margin-bottom: 0px;
  max-height: 610px;
  min-height: 464px;
  height: calc(100% - 295px);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 26px 80px rgba(0, 0, 0, 0.2);
  border-radius: 8px;

  .cus-msg-card.all-filter-card {
    box-sizing: border-box;
    border-radius: 10px;
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
    height: 100%;
    .content {
      padding: 20px;
      max-height: 424px;
      height: calc(100% - 180px);
      overflow-x: hidden;
      overflow-y: auto;
      margin-right: 4px;
      &::-webkit-scrollbar {
        background-color: white !important;
        width: 6px !important;
      }
      &::-webkit-scrollbar-thumb{
        background: #CAD2DA !important;
        border-radius: 50px !important;
      }
      .horizontal-line .el-checkbox__input {
        line-height: 0.5;
      }
    }
    .card-bottom-part {
      display: flex;
      width: 100%;
      border-top: 1px solid #CAD2DA;
      justify-content: space-between;
      padding: 13px 15px 14px 25px;
      max-width: 433px;
      align-items: center;
      span {
        cursor: pointer;
      }
      .all-filters-button-flex{
        display: flex;
      }
      .transcript-search-cancel-btn{
        padding: 10px 16px;
        // color: #202223;
        color: var(--site-button-cancel-btn-primary-color);
        border: 1px solid var(--site-button-cancel-btn-primary-border-color);
        border-radius: 5px;
        height: 17px;
        width: 45px;
        position: relative;
        left: -22px;
        top: 7px;
        font-size: 14.22px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .transcript-search-apply-btn {
        padding: 10px 16px;
        cursor: pointer;
        margin-left: 10px;
        margin-right: 13px;
        background: var(--site-button-primary-btn-background-primary-color);
        color: var(--site-button-primary-btn-text-primary-color);
        border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
        border-radius: 5px;
        position: relative;
        left: -6px;
        top: 6px;
        height: 17px;
        width: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14.22px;
      }
      .transcript-search-apply-btn:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .transcript-search-apply-btn:active {
        background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
      }
      .transcript-search-apply-btn:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .transcript-search-apply-btn.disabled {
        opacity: 0.5 !important;
        pointer-events: none;
      }
      .wrapper {
        cursor: not-allowed;
      }
    }

    .signal-flex {
      display: flex;
      align-items: center;
      gap: 6px;

      .signal-icon {
        height: 20px;
        width: 20px;
      }
    }

    .mutiple-select-section{
    .el-dropdown-menu__item{
      display: flex;
      margin-top: 18px;
      flex-direction: column;
    }
    .el-dropdown-menu__item {
        display: flex;
        margin-top: 15px;
        flex-direction: column;
        padding: 0px !important;
      }
      .el-input {
        border: 1px solid #CAD2DA;
        border-radius: 5px;
        padding: 1px;
        width: 94.5%;
        color: var(--site-font-tertiary-color);
        font-size: 14px;
      }
      .el-input__inner {
        border: none !important;
      }
      .el-select__input {
        margin-left: 1px;
      }
      .filter-header {
        color: var(--site-font-secondary-color);
        margin-bottom: 10px !important;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 14px;
        font-weight: 500 !important;
      }
      .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: transparent !important;
        color: var(--site-font-secondary-color) !important;
      }
      .el-tag.el-tag--info {
        background-color: #F2F3F3;
        border-color: #F2F3F3;
        color: var(--site-font-tertiary-color);
        font-size: 14px;
        max-width: 211px !important;
        width: fit-content;
        margin-left: -2px !important;
        padding-left: 5px !important;
        padding-right: 9px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .el-tag.el-tag--info .el-tag__close {
        color: #909399;
        display: none;
      }
      .el-select__tags {
        margin-left: 6px !important;
      }
      .el-select .el-input .el-select__caret {
        color: #5C5F62 !important;
      }

    }
  }
  .sentiment {
    width: 100%;
    //border-bottom: 1px solid #CAD2DA; //commented out for OC-1171
    height: 100px;
    //margin-bottom: 25px; //commented out for OC-1171
  }
  .feedback {
    width: 100%;
    height: 100px;
  }

  .contact-reasons .all-filter-top-two-title {
    // margin-top: 30px;
    margin-top: 0px;
    margin-bottom: 17px;
    display: inline-block;
    font-size: 14.22px;
    color: #202223;
    width: fit-content;
  }
  .agent-filters {
    .all-filter-top-two-title {
      margin-bottom: 20px;
      margin-top: 20px;
      display: inline-block;
      font-size: 14.22px;
      color: #202223;
      width: fit-content;
    }
    .agent-container {
      width: 80%;
      margin-top: -30px;
      .filter-title{
        color: #202223 !important;
        font-size: 14.22px;
        margin-bottom: 7px;
        &:hover{
          color: #202223 !important;
        }
      }
    }
    .agent-time-filter {
      .dash {
        right: -1px !important
      }

      div.min-hint {
        right: 34px;
      }
      div.max-hint {
        left: 38px;
      }
      .agent-time-title {
        margin-top: 20px;
        font-size: 14px;
        color: #202223;
      }
      .time{
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        margin-left: 0px !important;
        margin-bottom: 6px !important;
        .vue__time-picker {
          width: 11em !important;
          margin-right: 2px;
          min-width: 13.5em !important;
          right: 0px !important;
          .controls{
            align-items: center;
            .clear-btn {
              color: #5C5F62;
            }
          }
          .dropdown{
            width: 14em !important;
            height: 17em !important;
            top: calc(2.2em + 7px) !important;
            .select-list{
              width: 14em !important;
              height: 17em !important;
            }
            ul li:not([disabled]).active {
              background: #E8F1FF;
              color: #2A2E32;
            }
            ul li {
              line-height: 40px;
            }
            .hint {
              font-size: 14px;
              color: #2A2E32 !important;
            }
            ul{
              &::-webkit-scrollbar {
                background-color: white !important;
                width: 15px !important;
              }
              &::-webkit-scrollbar-thumb{
                border-radius: 10px;
                background: #CAD2DA !important;
                border-radius: 50px !important;
              }
            }
          }
        }
        input.display-time {
          border: 1px solid #CAD2DA;
          width: 14em !important;
          height: 2.6em;
          position: relative;
          border-radius: 4px;
          right: 9px;
          left: -2px;
          color: #2A2E32;
          margin-right: 0px;
          padding: 0.3em 0.5em;
          font-size: 1em;
        }
        input.display-time:focus {
          outline: none;
          border: 2px solid #106FBC;
          border-radius: 4px;
        }
      }
      .flex {
        left: 0px;
      }
      .clear-btn {
          position: relative;
          bottom: -3px;
          right: 8px;
          // right: 174px;
          font-size: 14.22px;
          color: #106FBC;
          border: none !important;
          padding: 0px;
          .char {
            margin-left: auto;
          }
      }
      .invalid-time-range {
        background: #F1D3D5;
        background-image: url("../../../assets/icons/icon_red_stop.svg");
        background-repeat: no-repeat;
        background-size: 14px;
        background-position-x: 10px;
        background-position-y: center;
        font-size: 13px;
        color: #59333E;
        border-radius: 5px;
        width: 245px;
        padding: 10px 0 10px 32px;
        line-height: 1;
        z-index: 1;
      }
    }
  }
  .all-filters-btn .applied-filter-number {
    color: #214586;
  }
  .horizontal-line .besbas_signals {
    margin-top: 6px;
    border-bottom: 1px solid #CAD2DA;
    .el-checkbox-group{
      padding-bottom: 13px;
      /* overflow-y: auto; */
      display: block;
      .el-checkbox.checkbox.containment-checkbox{
        padding-bottom: 15px;
      }
      .el-checkbox__inner{
        border: 2px solid var(--primary-checkbox-button-border-color) !important;
        width: 16px;
        height: 16px;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: var(--primary-checkbox-button-check-color);
        border-color: var(--primary-checkbox-button-checked-border-color) !important;
      }
    }
  }
  .horizontal-line .el-checkbox-group {
    // height: 17px;
    padding-bottom: 28px;
    /* overflow-y: auto; */
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    .el-checkbox{
      display: flex;
      flex-direction: row;
      align-items: center;
      .el-checkbox__label {
        line-height: 24px;
        top: 0px;
        position: relative;
      }
    }
    span.el-checkbox__inner:hover {
      -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow)  !important;
      box-shadow: var(--primary-checkbox-button-hover-box-shadow) !important;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: var(--primary-checkbox-button-check-color);
      border-color: var(--primary-checkbox-button-checked-border-color) !important;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner::after {
      left: 5px;
      top: 2px;
    }
  }
  .all-filter-top-title{
    color:#214586;
    font-size: 15px;
    font-weight: bold;
    // margin-top: 40px;
  }
  .all-filter-top-two-title {
    // margin-top: 30px;
    position: relative;
    height: 24px;
    margin-bottom: 17px;
    display: inline-block;
    font-size: 14.22px;
    color: #202223;
    width: fit-content;

    .invalid-time-range {
      position: absolute;
      background: #F1D3D5;
      background-image: url("../../../assets/icons/icon_red_stop.svg");
      background-repeat: no-repeat;
      background-size: 14px;
      background-position-x: 10px;
      background-position-y: center;
      font-size: 14px;
      color: #59333E;
      border-radius: 5px;
      width: 252px;
      padding: 10px 0 10px 32px;
      line-height: 1;
      z-index: 1;
      top: 0px;
    }
  }
  .horizontal-line .handoffs {
    .invalid-time-range {
      position: absolute;
      background: #F1D3D5;
      background-image: url("../../../assets/icons/icon_red_stop.svg");
      background-repeat: no-repeat;
      background-size: 14px;
      background-position-x: 10px;
      background-position-y: center;
      font-size: 14px;
      color: #59333E;
      border-radius: 5px;
      width: 283px;
      padding: 10px 0 10px 32px;
      line-height: 1;
      z-index: 1;
      top: 0px;
    }
    .time {
      .el-input-number.el-input-number--mini {
        border: 2px solid transparent;
      }
      .el-input-number.el-input-number--mini.has-error {
        border: 2px solid #E6494C;
        outline: unset;
        border-radius: 7px;
      }
      .el-input-number.el-input-number--mini.is-focused {
        border: 2px solid #106FBC;
        outline: unset;
        border-radius: 4px;
      }
    }
  }
  .flex-select-all {
    margin-left: auto;
    width: fit-content;
    margin-top: 3px;
    float: right;
  }
  .all-filter-header{
    position: relative;
    // left: 23px;
    color: var(--site-font-primary-color);
    font-size: 15px;
    align-content:left;
    font-weight: bold;
  }
  .dash {
    padding: 0px 0px;
    color: #CAD2DA;
    font-size: 25px;
    position: relative;
    right: 11px;
  }
  .response-time, .handle-time {
    .time .dash {
      padding: 0px 5px;
      color: #CAD2DA;
      font-size: 25px;
      position: relative;
      right: -24px;
    }
    // .time-picker-overlay {
      // display: none;
    // }
  }
  .reset-btn{
    cursor: pointer;
  }
  .horizontal-line {
    // border-bottom: 1px solid #e7e6e6;
    margin-bottom: 6px;
    // padding-bottom: 10px;
    // margin-right: -21px;
    // margin-left: -25px;
    padding-bottom: 10px;
    .min-handling-time-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-handling-time-label {
      margin-left: 126px;
      font-size: 12px;
    }
    .min-response-time-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-response-time-label {
      margin-left: 126px;
      font-size: 12px;
    }
    .min-handoffs-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-handoffs-label {
      margin-left: 126px;
      font-size: 12px;
    }
    span.contact-reason-dropdown-text {
      position: relative;
      bottom: 8px;
      // right: 33px;
      color: #647B86;
      font-weight: normal;
      font-size: 15px;
      display: flex;
    }
    span.contact-reason-dropdown-text.grey-shade {
      background-color: #F2F3F3;
      width: fit-content;
      padding: 4px;
      border-radius: 5px;
    }
    span.contact-reason-dropdown-text-all {
      position: relative;
      bottom: 2px;
      // right: 33px;
      color: #C4C4C4;
      font-weight: normal;
      font-size: 15px;
      margin-right: 50px;
      display: flex;
      padding-left: 3px;
    }
    // span.contact-reason-dropdown-text-all.grey-shade {
    //   background-color: #F2F3F3;
    //   width: fit-content;
    //   padding: 4px;
    //   border-radius: 5px;
    // }
    .el-icon--right.grey-shade {
      float: right;
      position: relative;
      // left: 35px;
      bottom: 25px;
      color: #5C5F62;
    }
    .el-icon--right {
      float: right;
      position: relative;
      // left: 35px;
      bottom: 17px;
      color: #5C5F62;
    }
    .el-icon--right-selected {
      float: right;
      position: relative;
      bottom: 25px;
      color: #5C5F62;
    }
    div.min-hint {
      position: relative;
      right: 30px;
      font-size: 14px;
      color: #4B5158;
    }
    div.max-hint {
      position: relative;
      left: 33px;
      font-size: 14px;
      color: #4B5158;
    }
    label.el-checkbox.checkbox.containment-checkbox {
      position: relative;
      // right: 25px;
    }
    span.max-hint.last-max-hint {
      position: relative;
      // right: 90px;
    }
    .reset-btn{
      text-decoration: underline;
      color: var(--site-font-primary-color);
      font-size: 13px;
      align-self: left;
      // left: -40px;
      position: relative;
    }
    button.el-button.contact-reasons-dropdown.el-button--default.is-plain.el-dropdown-selfdefine {
      border-radius: 4px;
      width: 80% !important;
      padding-left: 16px;
      padding-right: 9px;
      height: 40px;
      padding: 15px 6px 15px 3px;
      border: 1px #CAD2DA solid !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span.reset-btn.handoff-reset {
    // left: -46px !important;
    position: relative;
    }
    .contact-reasons {
      position: relative;
      padding-bottom: 20px;
      margin-bottom: 5px;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #CAD2DA;
      width: 100%;
    }

    .handle-time {
      margin-top: 20px;
      padding-bottom: 25px;
      width: 100% !important;
      border-bottom: 1px solid #CAD2DA;
      border-radius: 0px !important;

    }
    .response-time {
      //margin-bottom: 25px;
      padding-bottom: 25px;
      width: 100% !important;
      border-bottom: 1px solid #CAD2DA;
    }
    .handoffs {
      margin-bottom: 10px;
    }

    .title{
      margin-top: 0px !important;
    }
    .flex{
      // display: flex;
      justify-content: space-around;
      position: relative;
      // bottom: 14px;
      // left: 9px;
      display: flex;
      // margin-bottom: 22px !important;
      margin-top: 2px;
      width: 305px;
    }

    .top-part-flex{
      display: inline-flex;
      justify-content: space-around;
      position: relative;
      width: 100%;
      flex-direction: column;
      border-bottom: 1px solid #CAD2DA;
    }
    .containment {
      /* vertical-align: top; */
      position: relative;
      border-top: 1px solid #FFF;
      border-bottom: 1px solid #CAD2DA;
      margin-top: 0px;
      .all-filter-top-two-title {
        margin-top: 0px;
      }
    }
    .containment.with-border {
      .all-filter-top-two-title {
        margin-top: 19px;
      }
    }
    .el-button.is-plain:focus {
      border-color: #CCC;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: var(--site-font-primary-color);
    }
  }
  .time-picker {
    .clear-btn {
      padding: 2px 7px 0 7px;
    }
  }

  .card-bottom-part {
    display: flex;
    border-top: 1px solid #CAD2DA;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    button.el-button.submit-btn.el-button--default.is-round {
      margin-left: auto;
      padding: 5px 15px;
    }
    span {
      cursor: pointer;
    }
    div {
      margin-top: 5px;
    }
    .cancel-text{
      font-size: 14px;
      padding-left: 25px;
      padding-right: 25px;
    }
    .clear-btn {
      position: relative;
      top: 8px;
      left: 78px;
      // right: 174px;
      font-size: 14.22px;
      color: var(--site-button-cancel-btn-primary-color);
      border: 0px solid var(--site-button-cancel-btn-primary-border-color);
      padding: 0px;
      .char {
        margin-left: auto;
      }
    }
    .clear-filter-text{
      position: relative;
      // right: 21px;
      font-weight: normal;
      font-size: 14px;
    }
  }
  .el-button.is-plain:focus, .el-button.is-plain:hover {
    border-color: #DCDFE6;
  }
  .time {
    .vue__time-picker.time-picker {
      width: 11em !important;
      margin-right: 2px;
      min-width: 13.5em !important;
      // right: -24px !important;
    }
  }
  .popper__arrow, .popper__arrow::after{
    display: none !important;
  }

}

/**
.allFilters-popover.contact-reason-transcript {
  height: calc(100% - 345px);
  top: 325px !important;
}
*/

.all-filters-contact-reasons {
  padding: 0 0 0px 0;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0);
  border: 1px solid #EBEEF5 !important;
  width: 310px;

  .cus-msg-card {
    border-radius: 10px;
    .horizontal-line {
      margin-right: 0px;
      margin-left: 0px;
      border: 1px #e7e6e6 solid;
      padding-top: 10px;
      padding-bottom: 0px;
      padding-right: 6px;
      border-bottom: 0px;
      border-right: 0px;
      overflow: hidden;
      .reg-inp {
        background: #ffffff;
        border: 1px solid #c0c0c0;
        box-sizing: border-box;
        border-radius: 4px;
        margin-left: 15px !important;
        margin-right: 15px !important;
        margin-bottom: 15px;
        padding: 5px 21px 3px 15px;
        width: 280px;
      }
      .flex-reset-all {
        display: inline;
        font-size: 12px;
        float: right;
        margin-top: 12px;
        margin-right: 9px;
        text-decoration: underline;
      }
      .btn-select-all {
        float: right;
        font-size: 12px;
        margin-right: 15px;
        margin-top: 8px;
        cursor: pointer;
        text-decoration: underline;
        background-image: var(--icon_close_popup);
        background-repeat: no-repeat;
        height: 36px;
        width: 36px;
      }
      .fa-times-circle {
        position: relative;
        left: -35px;
        bottom: 1px;
        color: #214586;
        font-size: 12px;
        cursor: pointer;
      }
      i.fas.fa-times-circle.circle-all-filter {
        // left: 365px !important;
        // bottom: 38px !important;
      }
      .input-hight-light {
        background-color: #E8F1FF !important;
      }
      .check-box-section {
        height: 265px;
        overflow-y: auto;
        overflow-x: hidden;
          .no-matching-data-text{
            display: flex;
            justify-content: center;
          }
        .el-checkbox{
          .el-checkbox__label {
            color: var(--site-font-primary-color) !important;
            width: 250px !important;
          }
        }
        &::-webkit-scrollbar {
          background-color: white !important;
          width: 6px !important;
        }
        &::-webkit-scrollbar-thumb{
          background: #CAD2DA !important;
          border-radius: 50px !important;
        }
      }
      .check-box-section .el-checkbox {
        margin-left: 16px;
        padding-bottom: 4px;
        margin-bottom: 10px
      }
      span.el-checkbox__inner {
        border: 2px solid var(--primary-checkbox-button-border-color) !important;
      }
      span.el-checkbox__inner:hover {
        -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow);
        box-shadow: var(--primary-checkbox-button-hover-box-shadow);
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: var(--primary-checkbox-button-check-color);
        border-color: var(--primary-checkbox-button-checked-border-color) !important;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner::after {
        left: 3px;
        top: 0px;
      }
    }
    .horizontal-line .el-checkbox-group {
      height: fit-content;
      padding-bottom: 0px;
      /* overflow-y: auto; */
      // display: flex;
      width: 378px;

      .el-checkbox {
        color: var(--site-font-primary-color);
        margin-bottom: 10px;
        margin-left: 15px;
        margin-right: 5px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        .el-checkbox__input {
          line-height: 1.5;
        }
        .el-checkbox__label {
          // max-width: 230px;
          // width: 95%;
          width: 100%;
          color: var(--site-font-primary-color);
          .display-topic-name {
            display: inline-block;
            outline: none;
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .topic-number {
            float: right;
          }
        }
        .el-checkbox__inner {
          top: 0px;
        }
        span.el-checkbox__inner:hover {
          -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow);
          box-shadow: var(--primary-checkbox-button-hover-box-shadow);
        }
      }
    }
  }
}

// .allFilters-popover.agent-popper {
//   width: 270px;
//   border: none;
//   min-width: 303px !important;
// }
.agent-popper {
  width: 270px;
  border: none;
  min-width: 303px !important;

  .el-scrollbar {
    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 50px !important;
    }
  }

  .el-select-dropdown__wrap {
    max-height: 206px !important;
  }
  .el-popper .popper__arrow, .el-popper .popper__arrow::after {
    display: none !important;
  }
  .el-select-dropdown__list {
    padding: 0px 0;

    .el-select-dropdown__item.selected {
      border: none;
      font-weight: unset;
    }
    .el-select-dropdown__item {
      padding: 0 26px 0 12px;
      margin: 7px 0px;
      border-radius: 5px;
    }
    .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: transparent;
    }
  }
  .el-select-dropdown__list .el-select-dropdown__item.selected {
    background-color: #E8F1FF !important;
    color: #000 !important;
    border-radius: 0px !important;
  }
  .el-select-dropdown__wrap {
    background: white;
    color: var(--site-font-tertiary-color) !important;
  }
  .el-select-dropdown__item {
    color: var(--site-font-tertiary-color) !important;
  }
  .el-select-dropdown__item:hover {
    background: #F4F6F8 !important;
    color: var(--site-font-tertiary-color) !important;
    border-radius: 0px !important;
  }

  .el-select-dropdown__item {
    color: var(--site-font-tertiary-color) !important;
  }
  .el-select-dropdown__list {
    padding: 0px 0;
    background: white;
    color: var(--site-font-tertiary-color) !important;
  }
  .el-select-dropdown__item.selected::after {
    right: 11px;
    top: 5px !important;
    content: url('../../../assets/icons/icon_agent_dropdown_check.svg') !important;
    top: 3px !important;
  }
  .popper__arrow::after {
    border-bottom-color: transparent !important;
    background: transparent;
  }
  .popper__arrow{
    display: none !important;
  }
}

.el-popper .popper__arrow, .el-popper .popper__arrow::after {
  display: none !important;
}


.allFilters-popover.interactions.trending-topic-detail {
  height: calc(100% - 378px);

  .cus-msg-card.all-filter-card {
    .content {
      max-height: 448px;
      height: calc(100% - 158px);
      padding: 0px 20px 20px 20px;
    }
    .card-bottom-part {
      padding: 10px 15px 0px 25px;
    }
  }
}

</style>